(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9327],{

/***/ 22009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ HorizontalLine; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _config_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93957);


var HorizontalLine = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
  displayName: "Divider__HorizontalLine",
  componentId: "sc-r6t1n3-0"
})(["display:", ";width:", ";height:", ";background-color:", ";"], function (props) {
  return props.display || "flex";
}, function (props) {
  return props.width;
}, function (props) {
  return props.height || "0.125rem";
}, function (props) {
  return props.color;
});

/***/ }),

/***/ 68924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28658);
/* harmony import */ var _HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90892);
/* harmony import */ var _HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_owl_carousel2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68820);
/* harmony import */ var react_owl_carousel2__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_owl_carousel2__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _atoms_buttons_carouselButton_CarouselButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30698);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64036);
/* harmony import */ var _atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79549);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99599);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);











var HeroCarousel = function HeroCarousel(_ref) {
  var _ref$slides = _ref.slides,
      slides = _ref$slides === void 0 ? [] : _ref$slides,
      btnVariant = _ref.btnVariant,
      slideIndex = _ref.slideIndex,
      carouselBtnVariant = _ref.carouselBtnVariant,
      id = _ref.id,
      setCarouselPriority = _ref.setCarouselPriority,
      page = _ref.page;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      previousNavClass = _useState[0],
      setPreviousNavClass = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      nextNavClass = _useState2[0],
      setNextNavClass = _useState2[1];

  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_4__/* .componentResize */ .Y4)();
  var heroCarousel;

  var next = function next() {
    if (heroCarousel) {
      heroCarousel.next(600);
    }
  };

  var prev = function prev() {
    if (heroCarousel) {
      heroCarousel.prev(600);
    }
  };

  var isMultiple = function isMultiple() {
    return slides.length > 1;
  };

  var carouselOptions = {
    nav: false,
    autoplay: false,
    animateIn: "animate__fadeIn",
    margin: 0,
    autoWidth: true,
    lazyLoad: true,
    dotsClass: "".concat((_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["owl-dots"])),
    dotClass: "".concat((_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["owl-dot"])),
    slideBy: 1,
    dots: isMultiple(),
    loop: false,
    responsive: {
      0: {
        slideBy: 1
      }
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (page && page == _config_labels__WEBPACK_IMPORTED_MODULE_6__/* ["default"].lbl_buy_bundle */ .Z.lbl_buy_bundle && slideIndex) {
      heroCarousel.goTo(slideIndex);
    }
  }, [slideIndex]);
  var events = {
    onInitialized: function onInitialized(event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function onTranslated(event) {
      toggleCarouselNavDisabled(event);

      if (page && page == _config_labels__WEBPACK_IMPORTED_MODULE_6__/* ["default"].lbl_buy_bundle */ .Z.lbl_buy_bundle) {
        setCarouselPriority(event.item.index);
      }
    }
  };

  function toggleCarouselNavDisabled(event) {
    var index = event.item.index;
    var minimum = 0;
    var maximum = event.item.count;
    var previousNav = index <= minimum ? "disabled" : "";
    var nextNav = index + carouselOptions.responsive[event.relatedTarget._breakpoint].slideBy >= maximum ? "disabled" : "";
    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: (_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["hero-carousel"]),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((react_owl_carousel2__WEBPACK_IMPORTED_MODULE_2___default()), {
      ref: function ref(c) {
        return heroCarousel = c;
      },
      options: carouselOptions,
      events: events,
      children: slides.map(function (_slide, i) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: (_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default().slide),
          style: {
            backgroundImage: _slide.mobileImage && isMobile ? "url(".concat(_slide.mobileImage, ")") : "url(".concat(_slide.image, ")")
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Container, {
            id: _slide.id,
            "data-cms-title": _slide.title ? _slide.title : _slide.heading,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Row, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Col, {
                xs: 12,
                md: 11,
                lg: 6,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
                  className: "".concat((_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default().content), " ").concat((_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default())[_slide.theme ? "content--" + _slide.theme.toLowerCase() : "content--light"]),
                  children: [Boolean(_slide.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
                    className: (_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default().content__title),
                    children: _slide.title
                  }), Boolean(_slide.heading) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
                    className: (_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default().content__heading),
                    children: _slide.heading
                  }), Boolean(_slide.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
                    className: (_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default().content__description),
                    dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_4__/* .createMarkup */ .KU)(_slide.description)
                  }), Boolean(_slide.callToActionLabel) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    className: (_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default().content__cta),
                    id: "".concat(_slide.id, "_CTABtn_").concat(i),
                    url: _slide.callToActionUri,
                    isOpenNewTab: _slide.isOpenNewTab,
                    handleClick: function handleClick() {},
                    variant: btnVariant,
                    children: _slide.callToActionLabel
                  })]
                })
              })
            })
          })
        }, i);
      })
    }), isMultiple() && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "custom-owl--nav ".concat((_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default().nav)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms_buttons_carouselButton_CarouselButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        prev: true,
        handleClick: prev,
        className: "".concat(previousNavClass, " ").concat((_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["prev-arrow"])),
        btnTheme: carouselBtnVariant.toLowerCase(),
        id: "".concat(id) + "_arrowNxtBtn"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms_buttons_carouselButton_CarouselButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        next: true,
        handleClick: next,
        className: "".concat(nextNavClass, " ").concat((_HeroCarousel_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["next-arrow"])),
        btnTheme: carouselBtnVariant.toLowerCase(),
        id: "".concat(id) + "_arrowBackBtn"
      })]
    })]
  });
};

HeroCarousel.defaultProps = {
  slides: [],
  btnVariant: "",
  slideIndex: 0,
  carouselBtnVariant: "Dark"
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroCarousel);

/***/ }),

/***/ 59312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28658);
/* harmony import */ var _atoms_buttons_carouselButton_CarouselButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30698);
/* harmony import */ var _Carousel_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98679);
/* harmony import */ var _Carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      showNav = _ref.showNav,
      center = _ref.center,
      navClassName = _ref.navClassName,
      className = _ref.className;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      previousNavClass = _useState[0],
      setPreviousNavClass = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      nextNavClass = _useState2[0],
      setNextNavClass = _useState2[1];

  var options = {
    items: 1,
    center: center,
    nav: showNav,
    autoplay: false,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots owl--dots--show",
    dotClass: "owl--dot owl--dot--red",
    animateIn: "animate__fadeIn",
    margin: 0,
    autoWidth: false,
    dots: true,
    slideBy: 1,
    responsive: {
      0: {
        slideBy: 1
      }
    }
  };
  var carousel;

  var next = function next() {
    if (carousel) {
      carousel.next(600);
    }
  };

  var prev = function prev() {
    if (carousel) {
      carousel.prev(600);
    }
  };

  var events = {
    onInitialized: function onInitialized(event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function onTranslated(event) {
      toggleCarouselNavDisabled(event);
    }
  };

  function toggleCarouselNavDisabled(event) {
    var index = event.item.index;
    var minimum = 0;
    var maximum = event.item.count;
    var previousNav = index <= minimum ? "disabled" : "";
    var nextNav = index + options.responsive[event.relatedTarget._breakpoint].slideBy >= maximum ? "disabled" : "";
    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: "".concat((_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["carousel-container"]), " ").concat(className, " owl-wrapper"),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.OwlCarousel, {
      ref: function ref(c) {
        return carousel = c;
      },
      options: options,
      events: events,
      children: children
    }), showNav && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "custom-owl--nav ".concat(navClassName ? navClassName : ""),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_atoms_buttons_carouselButton_CarouselButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        prev: true,
        handleClick: prev,
        className: "".concat((_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow), " ").concat((_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["arrow--prev"]), " ").concat(previousNavClass),
        btnSize: "sm",
        id: "Carousel_arrowBackBtn"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_atoms_buttons_carouselButton_CarouselButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        next: true,
        handleClick: next,
        className: "".concat((_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow), " ").concat((_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["arrow--next"]), " ").concat(nextNavClass),
        btnSize: "sm",
        id: "Carousel_arrowNextBtn"
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Carousel);

/***/ }),

/***/ 62035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HomePageHeading; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _atoms_pageHeading_PageHeading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19456);
/* harmony import */ var _homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34057);
/* harmony import */ var _homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28658);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






function HomePageHeading(props) {
  var generateAlignment = function generateAlignment() {
    switch (props === null || props === void 0 ? void 0 : props.alignment) {
      case "left":
      case "LEFT":
        {
          return props !== null && props !== void 0 && props.alignment ? 'text-left' : "";
        }

      case "right":
      case "RIGHT":
        {
          return props !== null && props !== void 0 && props.alignment ? 'text-right' : "";
        }

      default:
        return 'text-center';
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__.Container, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "".concat((_homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["home-page-heading"]), " ").concat((_homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[props.className]),
      children: [props.mainHeadingRequired && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_atoms_pageHeading_PageHeading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        id: props.id,
        text: props.text,
        className: "".concat((_homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["main-heading"]), " ").concat(!props.isRegularFont && props.textClassName, " ").concat(generateAlignment(), " ")
      }), props.secondaryText && props.secondaryText !== "" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_atoms_pageHeading_PageHeading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        id: props.id,
        text: props.secondaryText,
        className: "".concat((_homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["secondary-heading"]), "  ").concat(props.textClassName, " ").concat((_homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[props.textClassName], " ").concat(generateAlignment(), " ")
      }), props.secondaryGreyText && props.secondaryGreyText !== "" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_atoms_pageHeading_PageHeading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        id: props.id,
        text: props.secondaryGreyText,
        className: "".concat((_homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["secondary-heading"]), " ").concat((_homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["secondary-grey-heading"]), "  ").concat((_homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[props.titleType && props.titleType], " ").concat(props.textClassName, " ").concat(generateAlignment(), " ")
      }), props.componentDescription && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_atoms_pageHeading_PageHeading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        id: props.id,
        level: 4,
        text: props.componentDescription,
        className: "".concat((_homePageHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["description-style"]), " ").concat(generateAlignment(), " ")
      })]
    })
  });
}
HomePageHeading.defaultProps = {
  className: "default"
};

/***/ }),

/***/ 2458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28658);
/* harmony import */ var _homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40001);
/* harmony import */ var _homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69152);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var HomeTabs = function HomeTabs(_ref) {
  var tabsContent = _ref.tabsContent,
      variant = _ref.variant,
      tabType = _ref.tabType,
      alignment = _ref.alignment,
      className = _ref.className,
      analytics = _ref.analytics,
      selectedTab = _ref.selectedTab,
      selectTabHandler = _ref.selectTabHandler,
      page = _ref.page;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(tabsContent.length ? tabsContent[0].title : "unknown"),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var attributes = ["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"];

  var generateVariant = function generateVariant() {
    return variant ? "tabs-design__nav--" + variant : "";
  };

  var generateAlignment = function generateAlignment() {
    switch (alignment) {
      case "left":
      case "LEFT":
        return alignment ? "tabs-design__nav--" + alignment.toLowerCase() : "";
        break;

      case "RIGHT":
      case "right":
        return alignment ? "tabs-design__nav--" + alignment.toLowerCase() : "";
        break;

      default:
        return "tabs-design__nav--";
    }
  };

  var generateTabType = function generateTabType() {
    return tabType ? "tabs-design__nav--" + tabType : "";
  };

  var generateStyle = function generateStyle() {
    var tabStyle = generateTabType();
    var variantStyle = "";

    if (tabType != "button") {
      variantStyle = generateVariant();
    }

    return "".concat(tabStyle, " ").concat(variantStyle);
  };

  var generateTabLine = function generateTabLine() {
    if (generateVariant() === ("tabs-design__nav--black-with-line" || 0)) {
      return true;
    }
  };

  var generatePageSpecificClass = function generatePageSpecificClass() {
    var style = "nav-alignment";

    if (page && page == "upgrade") {
      style = "";
    }

    return style;
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (selectedTab && page && page == "upgrade") {
      setActiveTab(selectedTab);
    }
  }, [selectedTab]);

  var handleTabChange = function handleTabChange(eventKey) {
    setActiveTab(eventKey);

    if (page && page == "upgrade") {
      selectTabHandler(eventKey);
    }

    var linkName = analytics.link_name ? "".concat(analytics.link_name, " ").concat(eventKey) : eventKey;
    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_3__/* .link */ .p4(_objectSpread({
      link_type: "o",
      page_tool_name: linkName,
      page_tool_event: "use"
    }, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_3__/* .getUtagData */ .GS(attributes)));
    setTimeout(react_lazyload__WEBPACK_IMPORTED_MODULE_4__/* .forceCheck */ .be, 1000);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: tabsContent.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Tab.Container, {
      defaultActiveKey: tabsContent[0].title,
      activeKey: activeTab,
      onSelect: handleTabChange,
      mountOnEnter: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "".concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["home-tabs-container"]), " "),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Container, {
          className: (_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generateTabLine() && "underline"],
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Nav, {
            variant: "tabs",
            className: "".concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["tabs-design__nav"]), "  ").concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generateVariant()], " ").concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generateTabType()], " ").concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generateAlignment()], " ").concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generateStyle()], " ").concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generatePageSpecificClass()]),
            children: tabsContent.map(function (tab, index) {
              var _jsx2;

              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Nav.Item, {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Nav.Link, (_jsx2 = {
                  id: tab.title,
                  eventKey: tab.title,
                  bsPrefix: "".concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["tab-link"]), " ").concat(activeTab === tab.title ? (_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["tab-link--active"]) : "", " ").concat(activeTab == "Past usage & spend" || tab.title == "Past usage & spend" ? (_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["past-usage-tab"]) : "")
                }, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_jsx2, "id", "".concat(tab.title, "_").concat(index)), (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_jsx2, "children", tab.title), _jsx2))
              }, index);
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "".concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["tabs-design__content"]), " ").concat(page == "upgrade" ? (_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["upgrade-custom"]) : ""),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Tab.Content, {
            children: tabsContent.map(function (tab, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Tab.Pane, {
                eventKey: tab.title,
                children: tab.component
              }, index);
            })
          })
        })]
      })
    })
  });
};

HomeTabs.defaultProps = {
  tabsContent: [],
  variant: "home",
  analytics: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (HomeTabs);

/***/ }),

/***/ 92267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99305);
/* harmony import */ var _hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap_OverlayTrigger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95944);
/* harmony import */ var react_bootstrap_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43489);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);






var HotSpot = function HotSpot(_ref) {
  var _ref$dataPoints = _ref.dataPoints,
      dataPoints = _ref$dataPoints === void 0 ? [] : _ref$dataPoints,
      _ref$imgUrl = _ref.imgUrl,
      imgUrl = _ref$imgUrl === void 0 ? "" : _ref$imgUrl;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
    className: "".concat((_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["hot-spot"])),
    children: [dataPoints.map(function (point, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_OverlayTrigger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        placement: point.tip.placement,
        overlay: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          id: "tooltip-".concat(index),
          bsPrefix: "".concat((_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default().tooltip), " ").concat((_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["tooltip--" + point.tip.placement]),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default().tooltip__container),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
              className: "".concat((_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default().tooltip__arrow), " ").concat((_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["tooltip__arrow--" + point.tip.placement])
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
              className: (_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default().tooltip__heading),
              children: point.tip.heading
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
              className: (_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default().tooltip__description),
              children: point.tip.description
            })]
          })
        }),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
          className: "".concat((_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["hot-spot__point"]), " ").concat((_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default().lightbox)),
          style: {
            top: "".concat(point.top, "%"),
            left: "".concat(point.left, "%")
          }
        }, index)
      }, index);
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
      src: imgUrl,
      className: (_hotSpot_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["hot-spot__images"])
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (HotSpot);

/***/ }),

/***/ 47091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99599);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28658);
/* harmony import */ var _atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79549);
/* harmony import */ var _OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6696);
/* harmony import */ var _OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var IconEndOfTheList = function IconEndOfTheList(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("g", {
      strokeLinecap: "round",
      strokeWidth: "2",
      stroke: "#999",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("circle", {
        cy: "17.196",
        cx: "17",
        r: "15.833"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
        strokeLinejoin: "round",
        d: "M25.37 11 15.007 21.365 10.4 16.758"
      })]
    })
  }));
};

IconEndOfTheList.defaultProps = {
  width: "34",
  height: "35",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
};

var OrderHistoryLoadMore = function OrderHistoryLoadMore(_ref) {
  var totalPages = _ref.totalPages,
      pageNumber = _ref.pageNumber,
      pageInfo = _ref.pageInfo,
      onLoadMore = _ref.onLoadMore,
      buttonLabel = _ref.buttonLabel;
  var reachedEnd = totalPages === pageNumber;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_3__.CustomContainer, {
    className: (_OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["order-load-more"]),
    children: !reachedEnd ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
      className: "p-4",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_4__["default"], {
        variant: "outline black",
        handleClick: function handleClick(event) {
          return onLoadMore(event, pageInfo);
        },
        className: "".concat((_OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["order-load-more--btn"]), " mb-xs btn-outline-dark"),
        id: "load-more-btn",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("label", {
          children: buttonLabel || _config_labels__WEBPACK_IMPORTED_MODULE_2__/* ["default"].lbl_load_more_orders */ .Z.lbl_load_more_orders
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
        className: "pt-5",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(IconEndOfTheList, {
          className: (_OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["order-load-list-end"])
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
        className: (_OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["order-load-more--label"]),
        children: _config_labels__WEBPACK_IMPORTED_MODULE_2__/* ["default"].lbl_end_order_list */ .Z.lbl_end_order_list
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OrderHistoryLoadMore);

/***/ }),

/***/ 51859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SO": function() { return /* binding */ renderComponent; }
});

// UNUSED EXPORTS: imageCardSlider, renderPortlet, renderVideo

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/molecules/HeroCarousel/HeroCarousel.jsx
var HeroCarousel = __webpack_require__(68924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./components/molecules/homeTabs/HomeTabs.jsx
var HomeTabs = __webpack_require__(2458);
// EXTERNAL MODULE: ./components/molecules/homePageHeading/homePageHeading.jsx
var homePageHeading = __webpack_require__(62035);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-owl-carousel2/lib/OwlCarousel.js
var OwlCarousel = __webpack_require__(68820);
var OwlCarousel_default = /*#__PURE__*/__webpack_require__.n(OwlCarousel);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./components/molecules/cardsCarousel/cardsCarousel.module.scss
var cardsCarousel_module = __webpack_require__(70134);
var cardsCarousel_module_default = /*#__PURE__*/__webpack_require__.n(cardsCarousel_module);
// EXTERNAL MODULE: ./components/molecules/ProductCards/ProductCards.jsx + 2 modules
var ProductCards = __webpack_require__(14309);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./components/atoms/buttons/carouselButton/CarouselButton.jsx
var CarouselButton = __webpack_require__(30698);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/cardsCarousel/CardsCarousel.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













function CardsCarousel(_ref) {
  var _ref$cards = _ref.cards,
      cards = _ref$cards === void 0 ? [] : _ref$cards,
      _ref$collectionName = _ref.collectionName,
      collectionName = _ref$collectionName === void 0 ? "" : _ref$collectionName,
      alignment = _ref.alignment,
      _ref$tabName = _ref.tabName,
      tabName = _ref$tabName === void 0 ? "" : _ref$tabName;
  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < 768;
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 1024;

  var _useState = (0,react.useState)(""),
      previousNavClass = _useState[0],
      setPreviousNavClass = _useState[1];

  var _useState2 = (0,react.useState)(""),
      nextNavClass = _useState2[0],
      setNextNavClass = _useState2[1];

  var goToProducts = function goToProducts() {// Router.replace('/');
  };

  var productCarousel;

  var next = function next() {
    if (productCarousel) {
      productCarousel.next(600);
    }
  };

  var prev = function prev() {
    if (productCarousel) {
      productCarousel.prev(600);
    }
  };

  var carouselOptions = {
    nav: true,
    autoplay: false,
    animateIn: "animate__fadeIn",
    autoWidth: true,
    lazyLoad: true,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots pt-0",
    dotClass: "owl--dot",
    slideBy: 1,
    responsive: {
      0: {
        dots: true,
        margin: 0
      },
      1024: {
        dots: false,
        margin: 8
      }
    }
  };
  var events = {
    onInitialized: function onInitialized(event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function onTranslated(event) {
      toggleCarouselNavDisabled(event);
    }
  };

  function toggleCarouselNavDisabled(event) {
    var index = event.item.index;
    var minimum = 0;
    var maximum = event.item.count;
    var previousNav = index <= minimum ? "disabled" : "";
    var nextNav = index + carouselOptions.responsive[event.relatedTarget._breakpoint].slideBy >= maximum ? "disabled" : "";
    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  var handleBuyNow = function handleBuyNow(product) {
    var _product$categories, _product$categories$;

    var analyticsViewData = analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3"]);
    var analyticsData = {
      link_type: "o",
      link_name: "".concat(analyticsViewData.page_name, ": product select: ").concat(product.name).concat(tabName ? ": " + tabName : ""),
      sales_product_category: [product === null || product === void 0 ? void 0 : (_product$categories = product.categories) === null || _product$categories === void 0 ? void 0 : (_product$categories$ = _product$categories[0]) === null || _product$categories$ === void 0 ? void 0 : _product$categories$.name],
      sales_product_id: [product === null || product === void 0 ? void 0 : product.name],
      sales_product_price: [(0,helperServices/* getFinalPrice */.eZ)(product)],
      sales_product_quantity: [1]
    };

    if (product !== null && product !== void 0 && product.badges_label) {
      analyticsData.sales_promo_name = [product === null || product === void 0 ? void 0 : product.badges_label];
    }

    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsViewData), analyticsData));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "d-flex ".concat(!isTablet && alignment == "CENTER" ? "justify-content-center" : "justify-content-left"),
      children: [cards.length > 0 && isTablet && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (cardsCarousel_module_default())["content-container"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((OwlCarousel_default()), {
          ref: function ref(c) {
            return productCarousel = c;
          },
          options: carouselOptions,
          events: events,
          children: cards.map(function (item, index) {
            var _item$price_range, _item$price_range$max, _item$price_range$max2, _item$price_range2, _item$price_range2$ma, _item$price_range2$ma2, _item$price_range3, _item$price_range3$ma, _item$price_range3$ma2;

            return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "d-flex ".concat((cardsCarousel_module_default())["content-item"]),
              children: index === 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCards["default"], {
                className: (cardsCarousel_module_default())["mobile-card-view"],
                buttonClassName: (cardsCarousel_module_default())["custom-button-style"],
                priceRequired: true,
                itemName: item === null || item === void 0 ? void 0 : item.name,
                itemImage: item === null || item === void 0 ? void 0 : item.image.url,
                imageLabel: item === null || item === void 0 ? void 0 : item.image.label,
                maximumPrice: item === null || item === void 0 ? void 0 : (_item$price_range = item.price_range) === null || _item$price_range === void 0 ? void 0 : (_item$price_range$max = _item$price_range.maximum_price) === null || _item$price_range$max === void 0 ? void 0 : (_item$price_range$max2 = _item$price_range$max.regular_price) === null || _item$price_range$max2 === void 0 ? void 0 : _item$price_range$max2.value,
                minimumPrice: (0,helperServices/* getAmountOffValue */.Dd)(item) === "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) !== "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item),
                dealProductPrice: item === null || item === void 0 ? void 0 : (_item$price_range2 = item.price_range) === null || _item$price_range2 === void 0 ? void 0 : (_item$price_range2$ma = _item$price_range2.maximum_price) === null || _item$price_range2$ma === void 0 ? void 0 : (_item$price_range2$ma2 = _item$price_range2$ma.regular_price) === null || _item$price_range2$ma2 === void 0 ? void 0 : _item$price_range2$ma2.value,
                buttonLabelReq: labels/* default.lbl_buy_now */.Z.lbl_buy_now,
                isMobile: isMobile,
                promotionLabel: (item === null || item === void 0 ? void 0 : item.promotion_tag) != null ? (0,helperServices/* getPromotionLabel */.Wp)(item) : '',
                promotionVariant: (0,helperServices/* getPromotionVariant */.HM)(item),
                promotionLabelColor: (0,helperServices/* getPromotionLabel */.Wp)(item) === (item === null || item === void 0 ? void 0 : item.promotion_tag_label) ? item.promotion_tag_swatch : item !== null && item !== void 0 && item.badges_swatch ? item.badges_swatch : null,
                cardWidth: "15.625rem",
                imgWidth: "11.25rem",
                imgHeight: "11.25rem",
                sku: item === null || item === void 0 ? void 0 : item.sku,
                item: item,
                buyNowReq: true,
                id: item === null || item === void 0 ? void 0 : item.sku,
                "data-cms-title": collectionName ? "".concat(collectionName, ": ").concat(item.name) : item.name,
                ctaHandler: handleBuyNow
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCards["default"], {
                className: (cardsCarousel_module_default())["mobile-card-view"],
                buttonClassName: (cardsCarousel_module_default())["custom-button-style"],
                priceRequired: true,
                itemName: item === null || item === void 0 ? void 0 : item.name,
                itemImage: item === null || item === void 0 ? void 0 : item.image.url,
                imageLabel: item === null || item === void 0 ? void 0 : item.image.label,
                maximumPrice: item === null || item === void 0 ? void 0 : (_item$price_range3 = item.price_range) === null || _item$price_range3 === void 0 ? void 0 : (_item$price_range3$ma = _item$price_range3.maximum_price) === null || _item$price_range3$ma === void 0 ? void 0 : (_item$price_range3$ma2 = _item$price_range3$ma.regular_price) === null || _item$price_range3$ma2 === void 0 ? void 0 : _item$price_range3$ma2.value,
                minimumPrice: (0,helperServices/* getAmountOffValue */.Dd)(item) === "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) !== "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item),
                buttonLabelReq: labels/* default.lbl_buy_now */.Z.lbl_buy_now,
                isMobile: isMobile,
                promotionLabel: (item === null || item === void 0 ? void 0 : item.promotion_tag) != null ? (0,helperServices/* getPromotionLabel */.Wp)(item) : '',
                promotionVariant: (0,helperServices/* getPromotionVariant */.HM)(item),
                promotionLabelColor: (0,helperServices/* getPromotionLabel */.Wp)(item) === (item === null || item === void 0 ? void 0 : item.promotion_tag_label) ? item.promotion_tag_swatch : item !== null && item !== void 0 && item.badges_swatch ? item.badges_swatch : null,
                cardWidth: "15.625rem",
                imgWidth: "11.25rem",
                imgHeight: "11.25rem",
                sku: item === null || item === void 0 ? void 0 : item.sku,
                item: item,
                buyNowReq: true,
                id: item === null || item === void 0 ? void 0 : item.sku,
                "data-cms-title": collectionName ? "".concat(collectionName, ": ").concat(item.name) : item.name,
                ctaHandler: handleBuyNow
              })
            }, index);
          })
        }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "custom-owl--nav ".concat((cardsCarousel_module_default())["owl--nav"]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CarouselButton/* default */.Z, {
            prev: true,
            handleClick: prev,
            className: previousNavClass,
            id: "CardsCarousel_arrowBackBtn"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselButton/* default */.Z, {
            next: true,
            handleClick: next,
            className: nextNavClass,
            id: "CardsCarousel_arrowNextBtn"
          })]
        })]
      }), cards.length > 0 && !isTablet && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: " d-flex ",
        children: cards.map(function (item, index) {
          var _item$image, _item$image2, _item$price_range4, _item$price_range4$ma, _item$price_range4$ma2, _item$image3, _item$image4, _item$price_range5, _item$price_range5$ma, _item$price_range5$ma2;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "d-flex ".concat((cardsCarousel_module_default())["content-item"], " ").concat(alignment == "CENTER" ? "justify-content-center" : "justify-content-left", " mr-xs ml-sm-xs"),
            children: index === 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCards["default"], {
              className: (cardsCarousel_module_default())["mobile-card-view"],
              buttonClassName: (cardsCarousel_module_default())["custom-button-style"],
              priceRequired: true,
              itemName: item === null || item === void 0 ? void 0 : item.name,
              itemImage: item === null || item === void 0 ? void 0 : (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url,
              imageLabel: item === null || item === void 0 ? void 0 : (_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.label,
              maximumPrice: item === null || item === void 0 ? void 0 : (_item$price_range4 = item.price_range) === null || _item$price_range4 === void 0 ? void 0 : (_item$price_range4$ma = _item$price_range4.maximum_price) === null || _item$price_range4$ma === void 0 ? void 0 : (_item$price_range4$ma2 = _item$price_range4$ma.regular_price) === null || _item$price_range4$ma2 === void 0 ? void 0 : _item$price_range4$ma2.value,
              minimumPrice: (0,helperServices/* getAmountOffValue */.Dd)(item) === "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) !== "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item),
              buttonLabelReq: labels/* default.lbl_buy_now */.Z.lbl_buy_now,
              isMobile: isMobile,
              promotionLabel: (item === null || item === void 0 ? void 0 : item.promotion_tag) != null ? (0,helperServices/* getPromotionLabel */.Wp)(item) : '',
              promotionVariant: (0,helperServices/* getPromotionVariant */.HM)(item),
              promotionLabelColor: (0,helperServices/* getPromotionLabel */.Wp)(item) === item.promotion_tag_label ? item.promotion_tag_swatch : item.badges_swatch,
              cardWidth: "15.625rem",
              imgWidth: "11.25rem",
              imgHeight: "11.25rem",
              sku: item.sku,
              item: item,
              buyNowReq: true,
              id: item.sku,
              "data-cms-title": collectionName ? "".concat(collectionName, ": ").concat(item.name) : item.name,
              ctaHandler: handleBuyNow
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCards["default"], {
              className: (cardsCarousel_module_default())["mobile-card-view"],
              buttonClassName: (cardsCarousel_module_default())["custom-button-style"],
              priceRequired: true,
              itemName: item === null || item === void 0 ? void 0 : item.name,
              itemImage: item === null || item === void 0 ? void 0 : (_item$image3 = item.image) === null || _item$image3 === void 0 ? void 0 : _item$image3.url,
              imageLabel: item === null || item === void 0 ? void 0 : (_item$image4 = item.image) === null || _item$image4 === void 0 ? void 0 : _item$image4.label,
              maximumPrice: item === null || item === void 0 ? void 0 : (_item$price_range5 = item.price_range) === null || _item$price_range5 === void 0 ? void 0 : (_item$price_range5$ma = _item$price_range5.maximum_price) === null || _item$price_range5$ma === void 0 ? void 0 : (_item$price_range5$ma2 = _item$price_range5$ma.regular_price) === null || _item$price_range5$ma2 === void 0 ? void 0 : _item$price_range5$ma2.value,
              minimumPrice: (0,helperServices/* getAmountOffValue */.Dd)(item) === "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) !== "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item),
              buttonLabelReq: labels/* default.lbl_buy_now */.Z.lbl_buy_now,
              isMobile: isMobile === true,
              promotionLabel: (item === null || item === void 0 ? void 0 : item.promotion_tag) != null ? (0,helperServices/* getPromotionLabel */.Wp)(item) : '',
              promotionVariant: (0,helperServices/* getPromotionVariant */.HM)(item),
              promotionLabelColor: (0,helperServices/* getPromotionLabel */.Wp)(item) === (item === null || item === void 0 ? void 0 : item.promotion_tag_label) ? item.promotion_tag_swatch : item !== null && item !== void 0 && item.badges_swatch ? item.badges_swatch : null,
              cardWidth: "15.625rem",
              imgWidth: "11.25rem",
              imgHeight: "11.25rem",
              sku: item === null || item === void 0 ? void 0 : item.sku,
              item: item,
              buyNowReq: true,
              id: item === null || item === void 0 ? void 0 : item.sku,
              "data-cms-title": collectionName ? "".concat(collectionName, ": ").concat(item.name) : item.name,
              ctaHandler: handleBuyNow
            })
          }, item.name + index);
        })
      })]
    })
  });
}
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./components/organisms/DealCatalog/DealCatalog.module.scss
var DealCatalog_module = __webpack_require__(21979);
var DealCatalog_module_default = /*#__PURE__*/__webpack_require__.n(DealCatalog_module);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
// EXTERNAL MODULE: ./components/molecules/ProductCarousel/ProductCarousel.jsx
var ProductCarousel = __webpack_require__(32954);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./components/molecules/ProductGridList/productGridList.module.scss
var productGridList_module = __webpack_require__(72476);
var productGridList_module_default = /*#__PURE__*/__webpack_require__.n(productGridList_module);
// EXTERNAL MODULE: ./components/molecules/dealCard/DealCard.jsx
var DealCard = __webpack_require__(8005);
// EXTERNAL MODULE: ./components/molecules/viewOrderHistory/orderHistoryLoadMore/OrderHistoryLoadMore.jsx
var OrderHistoryLoadMore = __webpack_require__(47091);
;// CONCATENATED MODULE: ./components/molecules/ProductGridList/ProductGridList.jsx















var ProductGridList = function ProductGridList(props) {
  var _props$component;

  var _useState = (0,react.useState)([]),
      gridItems = _useState[0],
      setGridItems = _useState[1];

  var pageSize = (props === null || props === void 0 ? void 0 : (_props$component = props.component) === null || _props$component === void 0 ? void 0 : _props$component.numOfProducts) || 12;

  var _useState2 = (0,react.useState)(1),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      totalItems = _useState3[0],
      setTotalItems = _useState3[1];

  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() <= 576;
  var isTabletLandscape = (0,helperServices/* componentCheckSize */.Qj)() > 992;
  var router = (0,DependencyHelper.useRouter)();
  (0,react.useEffect)(function () {
    var _props$component2, _props$component2$API, _props$component3, _props$component3$pro;

    (0,helperServices/* showSpinner */.yh)();
    ajaxServices/* default.fetchGraphQLGetRequest */.Z.fetchGraphQLGetRequest(((props === null || props === void 0 ? void 0 : (_props$component2 = props.component) === null || _props$component2 === void 0 ? void 0 : (_props$component2$API = _props$component2.API) === null || _props$component2$API === void 0 ? void 0 : _props$component2$API.apiEndpoint) || "").replace("<productSku>", props === null || props === void 0 ? void 0 : (_props$component3 = props.component) === null || _props$component3 === void 0 ? void 0 : (_props$component3$pro = _props$component3.productCategory) === null || _props$component3$pro === void 0 ? void 0 : _props$component3$pro.join('","')).replace("<pageSize>", pageSize).replace("<currentPage>", page).split("=")[1]).then(function (response) {
      var items = page === 1 ? response.products.items || [] : [].concat((0,toConsumableArray/* default */.Z)(gridItems), (0,toConsumableArray/* default */.Z)(response.products.items || []));
      setTotalItems(response.products.total_count);
      setGridItems(items);
    })["catch"](function () {
      setGridItems([]);
    })["finally"](function () {
      return (0,helperServices/* hideSpinner */.v3)();
    });
  }, [page]);

  if (!gridItems.length) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((productGridList_module_default())["grid-container"], " ").concat(isMobile ? (productGridList_module_default())["grid-container__mobile"] : ""),
      children: gridItems.map(function (item, index) {
        var _item$price_range, _item$price_range$min, _item$price_range$min2, _item$price_range2, _item$price_range2$mi, _item$price_range2$mi2, _item$price_range3, _item$price_range3$ma, _item$price_range3$ma2;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: !props.isDeal ? (productGridList_module_default())["carousel-container"] : (productGridList_module_default())["carousel-container-deal"],
          children: props.isDeal ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Link, {
            legacyBehavior: true,
            href: {
              pathname: "".concat(helperServices/* urlPrefix */.wn, "/deal-details-page/").concat(item.sku),
              query: {
                contractSkus: item.sku
              }
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (productGridList_module_default())["dealcard-link"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DealCard/* default */.Z, {
                width: "100%",
                height: "32.938rem",
                img_width: "10rem",
                maxHeight: "33.5rem",
                img_height: "10rem",
                width_mobile: "17.5rem",
                height_mobile: "29.313rem",
                img_width_mobile: "7.5rem",
                img_height_mobile: "7.5rem",
                productName: item === null || item === void 0 ? void 0 : item.name,
                availableIn: props === null || props === void 0 ? void 0 : props.availableIn,
                endsIn: props === null || props === void 0 ? void 0 : props.endsIn,
                imgUrl: (0,helperServices/* getProductImageUrl */.G)(item, "image", "No_image"),
                imgUrl_mobile: (0,helperServices/* getProductImageUrl */.G)(item, "small_image", "No_image_1"),
                saveLabel: (item === null || item === void 0 ? void 0 : (_item$price_range = item.price_range) === null || _item$price_range === void 0 ? void 0 : (_item$price_range$min = _item$price_range.minimum_price) === null || _item$price_range$min === void 0 ? void 0 : (_item$price_range$min2 = _item$price_range$min.discount) === null || _item$price_range$min2 === void 0 ? void 0 : _item$price_range$min2.amount_off) != 0 && (item === null || item === void 0 ? void 0 : (_item$price_range2 = item.price_range) === null || _item$price_range2 === void 0 ? void 0 : (_item$price_range2$mi = _item$price_range2.minimum_price) === null || _item$price_range2$mi === void 0 ? void 0 : (_item$price_range2$mi2 = _item$price_range2$mi.discount) === null || _item$price_range2$mi2 === void 0 ? void 0 : _item$price_range2$mi2.amount_off),
                promotionLabel: (item === null || item === void 0 ? void 0 : item.promotion_tag) != null ? (0,helperServices/* getPromotionLabel */.Wp)(item) : '',
                promotionVariant: (0,helperServices/* getPromotionVariant */.HM)(item),
                promotionLabelColor: (0,helperServices/* getPromotionLabel */.Wp)(item) === (item === null || item === void 0 ? void 0 : item.promotion_tag_label) ? item.promotion_tag_swatch : item !== null && item !== void 0 && item.badges_swatch ? item.badges_swatch : null,
                planName: item.package_description ? item.package_description : "",
                highlights: (0,helperServices/* getHighlights */._Y)(item),
                originalPrice: item !== null && item !== void 0 && item.monthly_recurring ? item.monthly_recurring : "",
                offerPrice: item !== null && item !== void 0 && item.monthly_recurring ? item.monthly_recurring : "",
                prevPrice: item !== null && item !== void 0 && item.old_monthly_recurring ? item.old_monthly_recurring : "",
                numberOfMonths: item === null || item === void 0 ? void 0 : item.payment_terms_label,
                buttonText: labels/* default.lbl_see_details */.Z.lbl_see_details,
                deal_end_date: item === null || item === void 0 ? void 0 : item.deal_end_date,
                deal_go_live_date: item === null || item === void 0 ? void 0 : item.deal_go_live_date,
                deal_label: item === null || item === void 0 ? void 0 : item.deal_label,
                is_deal_locked: item === null || item === void 0 ? void 0 : item.is_deal_locked,
                item: item,
                id: item === null || item === void 0 ? void 0 : item.sku
              })
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCards["default"], {
            priceRequired: true,
            promotionLabel: (item === null || item === void 0 ? void 0 : item.promotion_tag) != null ? (0,helperServices/* getPromotionLabel */.Wp)(item) : '',
            promotionVariant: (0,helperServices/* getPromotionVariant */.HM)(item),
            promotionLabelColor: (0,helperServices/* getPromotionLabel */.Wp)(item) === (item === null || item === void 0 ? void 0 : item.promotion_tag_label) ? item.promotion_tag_swatch : item !== null && item !== void 0 && item.badges_swatch ? item.badges_swatch : null,
            maximumPrice: item === null || item === void 0 ? void 0 : (_item$price_range3 = item.price_range) === null || _item$price_range3 === void 0 ? void 0 : (_item$price_range3$ma = _item$price_range3.maximum_price) === null || _item$price_range3$ma === void 0 ? void 0 : (_item$price_range3$ma2 = _item$price_range3$ma.regular_price) === null || _item$price_range3$ma2 === void 0 ? void 0 : _item$price_range3$ma2.value,
            minimumPrice: (0,helperServices/* getAmountOffValue */.Dd)(item) === "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) !== "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item),
            isLowStock: (0,helperServices/* checkIsLowStock */.yB)(item),
            isOutOfStock: (0,helperServices/* checkIsOutOfStock */.zy)(item),
            finalPriceReq: (0,helperServices/* checkIsFinalPriceReq */.z0)(item),
            finalPrice: (0,helperServices/* getFinalPrice */.eZ)(item),
            percentOff: (0,helperServices/* getPercentOffValue */.FQ)(item),
            amountOff: (0,helperServices/* getAmountOffValue */.Dd)(item),
            offerStyle: (productGridList_module_default())["offer-style"],
            priceLabelProductStyle: (productGridList_module_default())["price-label-style"],
            itemName: item === null || item === void 0 ? void 0 : item.name,
            buyNowReq: true,
            itemImage: item === null || item === void 0 ? void 0 : item.image.url,
            buttonLabelReq: labels/* default.lbl_buy_now */.Z.lbl_buy_now,
            previousPriceReq: true,
            sku: item === null || item === void 0 ? void 0 : item.sku,
            isPrepaidOnly: (item === null || item === void 0 ? void 0 : item.bundle_product_price) === null || (item === null || item === void 0 ? void 0 : item.bundle_product_price) === undefined,
            dealProductPrice: item === null || item === void 0 ? void 0 : item.bundle_product_price,
            switchClass: "product-carousel",
            cardWidth: isTabletLandscape ? props.width : props.width_mobile,
            imgWidth: isTabletLandscape ? props.img_width : props.img_width_mobile,
            imgHeight: isTabletLandscape ? props.img_height : props.img_height_mobile,
            priceLabelClassName: (productGridList_module_default())["card-price-height"],
            deal_end_date: item === null || item === void 0 ? void 0 : item.deal_end_date,
            deal_go_live_date: item === null || item === void 0 ? void 0 : item.deal_go_live_date,
            deal_label: item === null || item === void 0 ? void 0 : item.deal_label,
            is_deal_locked: item === null || item === void 0 ? void 0 : item.is_deal_locked,
            item: item,
            id: item === null || item === void 0 ? void 0 : item.sku
          })
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderHistoryLoadMore/* default */.Z, {
      totalPages: Math.ceil(totalItems / pageSize),
      pageNumber: page,
      onLoadMore: function onLoadMore() {
        return setPage(function (currentPage) {
          return currentPage + 1;
        });
      },
      buttonLabel: props.isDeal ? labels/* default.lbl_show_more_deals */.Z.lbl_show_more_deals : labels/* default.lbl_show_more_products */.Z.lbl_show_more_products
    })]
  });
};

/* harmony default export */ var ProductGridList_ProductGridList = (ProductGridList);
;// CONCATENATED MODULE: ./components/organisms/DealCatalog/DealCatalog.jsx




function DealCatalog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DealCatalog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DealCatalog_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DealCatalog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var config = __webpack_require__(26125);

var env = config.env;
var server = config.envConfigs[env].server;
var url = "".concat(server).concat(config.graphqlUrl);
var urlPrefix = config.envConfigs[env].shoppingUrlPrefix;

var DealCatalog = function DealCatalog(_ref) {
  var component = _ref.component,
      analyticsData = _ref.analyticsData,
      campaignFlag = _ref.campaignFlag;
  var comingSoonColor = component.comingSoonColor,
      endingSoonColor = component.endingSoonColor;
  var router = (0,DependencyHelper.useRouter)();
  var tempKeys = component === null || component === void 0 ? void 0 : component.productCategory;
  var totalKeys = tempKeys.length;

  var _useState = (0,react.useState)([]),
      tabsToRender = _useState[0],
      pushTabs = _useState[1];

  var syncArray = [];
  var attributes = ["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"];
  var isAnalytics = false;

  var redirectToProducts = function redirectToProducts() {
    var url = component.callToActionUrl;

    if (component.callToActionUrl.includes("internal:")) {
      url = component.callToActionUrl.split("internal:")[1];
    }

    (0,helperServices/* goToUrl */.tt)(url, router);
    handleShopAllAnalytics();
  };

  var handleShopAllAnalytics = function handleShopAllAnalytics() {
    var viewData = analyticsUtag/* getUtagData */.GS(attributes);
    analyticsUtag/* link */.p4(DealCatalog_objectSpread(DealCatalog_objectSpread({}, viewData), {}, {
      link_type: "o",
      link_name: "".concat(viewData === null || viewData === void 0 ? void 0 : viewData.page_name, ": all deals: ").concat(component.title)
    }));
  };

  var handleProductCTA = function handleProductCTA(product) {
    var contracts = Array.isArray(product.contract_sku) ? product.contract_sku : ["".concat(product.contract_sku)];
    router.push({
      pathname: "".concat(urlPrefix, "/deal-details-page/").concat(product.sku),
      query: {
        contractSkus: contracts
      }
    }).then(function () {
       true && window.scrollTo(0, 0);
    });

    if (!isAnalytics) {
      var viewData = analyticsUtag/* getUtagData */.GS(attributes);
      var data = {
        link_type: "o",
        link_name: "".concat(viewData.page_name, ": deal select: ").concat(component.title, ": ").concat(product === null || product === void 0 ? void 0 : product.tabName),
        sales_product_category: [product === null || product === void 0 ? void 0 : product.categories],
        sales_product_id: [product === null || product === void 0 ? void 0 : product.name],
        sales_product_price: [product.monthly_recurring],
        sales_product_quantity: [1]
      };

      if (product !== null && product !== void 0 && product.promotion_tag_label) {
        data.sales_promo_name = [product === null || product === void 0 ? void 0 : product.promotion_tag_label];
      }

      if (product !== null && product !== void 0 && product.deal_end_date) {
        data.deal_expiry = (0,helperServices/* getDealExpiryTime */.uJ)(product === null || product === void 0 ? void 0 : product.deal_end_date);
      }

      if (product.old_monthly_recurring && product.old_monthly_recurring !== product.monthly_recurring) {
        data.sales_order_discount = Math.abs(product.old_monthly_recurring - product.monthly_recurring);
      }

      isAnalytics = true;
      analyticsUtag/* link */.p4(DealCatalog_objectSpread({}, data));
    }
  };

  var apiMethod = component.API.method ? component.API.method : component.API.single.method;
  var body = (0,helperServices/* getRequestBody */.aG)(component.API);
  var requestBodyUrl = apiMethod === "GET" ? body.replace(url, "") : body;

  var generateData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(requestBody, method, tempkey, allSku) {
      var results, sortedArray, updatedArray;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!(method === "GET")) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return ajaxServices/* default.fetchGraphQLGetRequest */.Z.fetchGraphQLGetRequest(requestBody.split("=")[1]);

            case 4:
              _context.t0 = _context.sent;
              _context.next = 10;
              break;

            case 7:
              _context.next = 9;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(requestBody);

            case 9:
              _context.t0 = _context.sent;

            case 10:
              results = _context.t0;
              sortedArray = [];
              allSku.forEach(function (item) {
                var _results$products;

                return results === null || results === void 0 ? void 0 : (_results$products = results.products) === null || _results$products === void 0 ? void 0 : _results$products.items.find(function (category) {
                  if (category.sku === item) {
                    var productWithTabName = DealCatalog_objectSpread({
                      tabName: tempkey
                    }, category);

                    sortedArray.push(productWithTabName);
                  }
                });
              });

              if (!Object.keys(component.productCategory[0]).includes("tab")) {
                syncArray.push(sortedArray);
              } else if (component.displayStyle === "Carousel") {
                syncArray.push({
                  title: tempkey,
                  component: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
                      className: "text-center ".concat((DealCatalog_module_default())["deal-carousel-container"]),
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCarousel/* default */.Z, {
                        ProductCarouselData: sortedArray,
                        isDeal: true,
                        width: "15.5rem",
                        availableIn: comingSoonColor,
                        endsIn: endingSoonColor,
                        img_width: "11.25rem",
                        img_height: "11.25rem",
                        width_mobile: "12.375rem",
                        img_width_mobile: "8.375rem",
                        img_height_mobile: "8.375rem",
                        navigateTo: handleProductCTA,
                        alignment: component === null || component === void 0 ? void 0 : component.heading_position,
                        campaignFlag: campaignFlag,
                        carouselId: "shop-deal-carousel"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
                      className: "text-center",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
                        className: "".concat((DealCatalog_module_default())["shop-all"]),
                        handleClick: handleShopAllAnalytics,
                        url: component.callToActionUrl,
                        isOpenNewTab: component === null || component === void 0 ? void 0 : component.isOpenNewTab,
                        variant: "outline grey",
                        id: "product-carousel",
                        children: component.buttonLabel ? component.buttonLabel : component.callToActionLabel
                      })
                    })]
                  })
                });
              } else {
                syncArray.push({
                  title: tempkey,
                  component: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
                    className: "text-center",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardsCarousel, {
                      cards: sortedArray
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
                      className: "".concat((DealCatalog_module_default())["shop-all"]),
                      handleClick: handleShopAllAnalytics,
                      url: component.callToActionUrl,
                      variant: "outline grey",
                      id: "cards-carousel",
                      children: component.buttonLabel ? component.buttonLabel : component.callToActionLabel
                    })]
                  })
                });
              }

            case 14:
              _context.prev = 14;
              updatedArray = [];

              if (Object.keys(component.API).includes("all") ? totalKeys + 1 : totalKeys) {
                if (!Object.keys(component.productCategory[0]).includes("tab")) {
                  updatedArray = syncArray;
                } else {
                  tempKeys.forEach(function (category) {
                    var newItem = syncArray.filter(function (item) {
                      if (category.tab === item.title) {
                        updatedArray.push(item);
                      }
                    });
                  });
                }
              }

              if (Object.keys(component.API).includes("all") && syncArray.filter(function (item) {
                return item.title === "All";
              }).length) {
                updatedArray.unshift(syncArray.filter(function (item) {
                  return item.title === "All";
                })[0]);
              }

              if (updatedArray.length === (Object.keys(component.API).includes("all") ? totalKeys + 1 : totalKeys)) {
                pushTabs(updatedArray);
              }

              return _context.finish(14);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0,, 14, 20]]);
    }));

    return function generateData(_x, _x2, _x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    function generateTabs() {
      return _generateTabs.apply(this, arguments);
    }

    function _generateTabs() {
      _generateTabs = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var newArray, newKeys, allkeys, requestBody, i, _allkeys, _requestBody;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (Object.keys(component.API).includes("all")) {
                  newArray = tempKeys.map(function (item) {
                    return item.productSku;
                  });
                  newKeys = [].concat.apply([], newArray);
                  allkeys = newKeys.join('","');
                  requestBody = (0,helperServices/* requestType */.rI)(component.API.all).replace("<productSku>", allkeys) || "";
                  generateData(requestBody, component.API.all.method, "All", newKeys);
                }

                for (i = 0; i < totalKeys; i++) {
                  _allkeys = tempKeys[i].productSku.join('","');
                  _requestBody = requestBodyUrl.replace("<productSku>", _allkeys) || "";
                  generateData(_requestBody, apiMethod, tempKeys[i].tab, tempKeys[i].productSku);
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _generateTabs.apply(this, arguments);
    }

    if (component.displayStyle !== "Grid") {
      generateTabs();
    }
  }, []);
  console.log(component);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
      text: component.title,
      secondaryText: component.displayStyle === "Grid" ? null : (component === null || component === void 0 ? void 0 : component.description) || component.title,
      textClassName: (DealCatalog_module_default()).heading,
      componentDescription: component.displayStyle === "Grid" ? component === null || component === void 0 ? void 0 : component.description : null,
      mainHeadingRequired: component === null || component === void 0 ? void 0 : component.description,
      alignment: (component === null || component === void 0 ? void 0 : component.heading_position) || "LEFT"
    }), component.displayStyle === "Grid" && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductGridList_ProductGridList, {
        isDeal: true,
        width: "315px",
        img_width: "11.25rem",
        img_height: "11.25rem",
        width_mobile: "12.375rem",
        img_width_mobile: "8.375rem",
        img_height_mobile: "8.375rem",
        navigateTo: redirectToProducts,
        component: component
      })
    }), !Object.keys(component.productCategory[0]).includes("tab") ? tabsToRender.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "pt-l",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCarousel/* default */.Z, {
        ProductCarouselData: tabsToRender[0],
        isDeal: true,
        hideButtons: component.displayStyle === "Grid",
        width: "15.5rem",
        img_width: "11.25rem",
        img_height: "11.25rem",
        width_mobile: "12.375rem",
        img_width_mobile: "8.375rem",
        img_height_mobile: "8.375rem",
        navigateTo: redirectToProducts
      })
    }) : tabsToRender.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(HomeTabs/* default */.Z, {
      tabsContent: tabsToRender,
      variant: component.tabStyle ? component.tabStyle : "line-secondary",
      tabType: component.tabType,
      className: "deal_catalog",
      alignment: component === null || component === void 0 ? void 0 : component.heading_position,
      analytics: {
        link_name: "".concat(analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.page_name, ": deal: ").concat(component.title, ":")
      }
    })]
  });
};

DealCatalog.defaultProps = {
  component: {},
  analyticsData: {}
};
/* harmony default export */ var DealCatalog_DealCatalog = (DealCatalog);
// EXTERNAL MODULE: ./components/organisms/productCatalog/productCatalog.module.scss
var productCatalog_module = __webpack_require__(54239);
var productCatalog_module_default = /*#__PURE__*/__webpack_require__.n(productCatalog_module);
;// CONCATENATED MODULE: ./components/organisms/productCatalog/ProductCatalog.jsx




function ProductCatalog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductCatalog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductCatalog_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductCatalog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var ProductCatalog_config = __webpack_require__(26125);

var ProductCatalog_env = ProductCatalog_config.env;
var ProductCatalog_server = ProductCatalog_config.envConfigs[ProductCatalog_env].server;
var ProductCatalog_url = "".concat(ProductCatalog_server).concat(ProductCatalog_config.graphqlUrl);

var ProductCatalog = function ProductCatalog(_ref) {
  var component = _ref.component,
      analyticsData = _ref.analyticsData;
  var tempKeys = component === null || component === void 0 ? void 0 : component.productCategory;
  var totalKeys = tempKeys.length;

  var _useState = (0,react.useState)([]),
      tabsToRender = _useState[0],
      pushTabs = _useState[1];

  var syncArray = [];

  var redirectToProducts = function redirectToProducts() {
    var viewData = analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"]);
    analyticsUtag/* link */.p4(ProductCatalog_objectSpread({
      link_type: "o",
      link_name: "".concat(viewData === null || viewData === void 0 ? void 0 : viewData.page_name, ": all products: ").concat(component.title)
    }, viewData));
  };

  var apiMethod = component.API.method ? component.API.method : component.API.single.method;
  var body = (0,helperServices/* getRequestBody */.aG)(component.API);
  var requestBodyUrl = apiMethod === "GET" ? body.replace(ProductCatalog_url, "") : body;
  (0,react.useEffect)(function () {
    function generateTabs() {
      return _generateTabs.apply(this, arguments);
    }

    function _generateTabs() {
      _generateTabs = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var newArray, newKeys, allkeys, requestBody, i, _allkeys, _requestBody;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (Object.keys(component.API).includes("all")) {
                  newArray = tempKeys.map(function (item) {
                    return item.productSku;
                  });
                  newKeys = [].concat.apply([], newArray);
                  allkeys = newKeys.join('","');
                  requestBody = (0,helperServices/* requestType */.rI)(component.API.all).replace("<productSku>", allkeys) || "";
                  generateData(requestBody, component.API.all.method, "All", newKeys);
                }

                for (i = 0; i < totalKeys; i++) {
                  _allkeys = tempKeys[i].productSku.join('","');
                  _requestBody = requestBodyUrl.replace("<productSku>", _allkeys) || "";
                  generateData(_requestBody, apiMethod, tempKeys[i].tab, tempKeys[i].productSku);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _generateTabs.apply(this, arguments);
    }

    if (component.displayStyle !== "Grid") {
      generateTabs();
    }
  }, []);
  (0,react.useEffect)(function () {
    if (component && component.callToActionUrl) {
      var _url = component.callToActionUrl;

      if (component.callToActionUrl.includes("internal:")) {
        _url = component.callToActionUrl.split("internal:")[1];
      }

      DependencyHelper.Router.prefetch(_url);
    }
  }, []);

  var generateData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(requestBody, method, tempkey, allSku) {
      var results, sortedArray, updatedArray;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (!(method === "GET")) {
                _context2.next = 7;
                break;
              }

              _context2.next = 4;
              return ajaxServices/* default.fetchGraphQLGetRequest */.Z.fetchGraphQLGetRequest(requestBody.split("=")[1]);

            case 4:
              _context2.t0 = _context2.sent;
              _context2.next = 10;
              break;

            case 7:
              _context2.next = 9;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(requestBody);

            case 9:
              _context2.t0 = _context2.sent;

            case 10:
              results = _context2.t0;
              sortedArray = [];
              allSku.forEach(function (item) {
                var _results$products;

                return results === null || results === void 0 ? void 0 : (_results$products = results.products) === null || _results$products === void 0 ? void 0 : _results$products.items.find(function (category) {
                  if (category.sku === item) {
                    sortedArray.push(category);
                  }
                });
              });

              if (!Object.keys(component.productCategory[0]).includes("tab")) {
                syncArray.push(sortedArray);
              } else if (component.displayStyle === "Carousel" || sortedArray.length > 5) {
                syncArray.push({
                  title: tempkey,
                  component: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
                      className: "text-center ".concat((productCatalog_module_default())["product-carousel-container"]),
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCarousel/* default */.Z, {
                        ProductCarouselData: sortedArray,
                        width: "100%",
                        img_width: "11.25rem",
                        img_height: "11.25rem",
                        width_mobile: "10.375rem",
                        img_width_mobile: "8.375rem",
                        img_height_mobile: "8.375rem",
                        alignment: component === null || component === void 0 ? void 0 : component.heading_position,
                        endsIn: component === null || component === void 0 ? void 0 : component.endingSoonColor,
                        availableIn: component === null || component === void 0 ? void 0 : component.comingSoonColor,
                        tabName: tempkey,
                        carouselId: "shop-product-carousel"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
                      className: "text-center",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
                        className: "".concat((productCatalog_module_default())["shop-all-big"]),
                        handleClick: redirectToProducts,
                        isOpenNewTab: component === null || component === void 0 ? void 0 : component.isOpenNewTab,
                        url: component.callToActionUrl,
                        variant: "outline grey",
                        id: "".concat(component.buttonLabel, "-btn"),
                        children: component.buttonLabel
                      })
                    })]
                  })
                });
              } else {
                syncArray.push({
                  title: tempkey,
                  component: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
                    className: "text-center",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardsCarousel, {
                      cards: sortedArray,
                      alignment: component === null || component === void 0 ? void 0 : component.heading_position,
                      tabName: tempkey
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
                      className: "".concat((productCatalog_module_default())["shop-all"]),
                      handleClick: redirectToProducts,
                      isOpenNewTab: component === null || component === void 0 ? void 0 : component.isOpenNewTab,
                      url: component.callToActionUrl,
                      variant: "outline black",
                      id: "".concat(component.buttonLabel, "-btn"),
                      children: component.buttonLabel
                    })]
                  })
                });
              }

            case 14:
              _context2.prev = 14;
              updatedArray = [];

              if (Object.keys(component.API).includes("all") ? totalKeys + 1 : totalKeys) {
                if (!Object.keys(component.productCategory[0]).includes("tab")) {
                  updatedArray = syncArray;
                } else {
                  tempKeys.forEach(function (category) {
                    var newItem = syncArray.filter(function (item) {
                      if (category.tab === item.title) {
                        updatedArray.push(item);
                      }
                    });
                  });
                }
              }

              if (Object.keys(component.API).includes("all") && syncArray.filter(function (item) {
                return item.title === "All";
              }).length) {
                updatedArray.unshift(syncArray.filter(function (item) {
                  return item.title === "All";
                })[0]);
              }

              if (updatedArray.length === (Object.keys(component.API).includes("all") ? totalKeys + 1 : totalKeys)) {
                pushTabs(updatedArray);
              }

              return _context2.finish(14);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0,, 14, 20]]);
    }));

    return function generateData(_x, _x2, _x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
      text: component.title,
      secondaryText: (component === null || component === void 0 ? void 0 : component.description) || component.title,
      alignment: (component === null || component === void 0 ? void 0 : component.heading_position) || "LEFT",
      textClassName: component.displayStyle === "Carousel" ? (productCatalog_module_default())["heading-carousel"] : "explore-our-section ".concat((productCatalog_module_default()).heading),
      isRegularFont: true,
      mainHeadingRequired: component.description,
      id: component.id ? component.id : 'product-catalog'
    }), !Object.keys(component.productCategory[0]).includes("tab") && tabsToRender.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "pt-l",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCarousel/* default */.Z, {
        ProductCarouselData: tabsToRender[0],
        hideButtons: component.displayStyle === "Grid",
        width: "100%",
        img_width: "11.25rem",
        img_height: "11.25rem",
        width_mobile: "10.375rem",
        img_width_mobile: "8.375rem",
        img_height_mobile: "8.375rem",
        alignment: component === null || component === void 0 ? void 0 : component.heading_position,
        isDeal: false
      })
    }), component.displayStyle === "Grid" && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
      className: "pb-xs",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductGridList_ProductGridList, {
        width: "315px",
        img_width: "11.25rem",
        img_height: "11.25rem",
        width_mobile: "12.375rem",
        img_width_mobile: "8.375rem",
        img_height_mobile: "8.375rem",
        navigateTo: redirectToProducts,
        component: component
      })
    }), tabsToRender.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(HomeTabs/* default */.Z, {
      tabsContent: tabsToRender,
      variant: component.tabStyle ? component.tabStyle : "line-secondary",
      className: "product_catalog",
      alignment: component === null || component === void 0 ? void 0 : component.heading_position,
      analytics: {
        link_name: "".concat(analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.page_name, ": product: ").concat(component.title, ":")
      }
    })]
  });
};

ProductCatalog.defaultProps = {
  component: {},
  analyticsData: {}
};
/* harmony default export */ var productCatalog_ProductCatalog = (ProductCatalog);
// EXTERNAL MODULE: ./components/molecules/imageCard/imageCard.module.scss
var imageCard_module = __webpack_require__(2116);
var imageCard_module_default = /*#__PURE__*/__webpack_require__.n(imageCard_module);
;// CONCATENATED MODULE: ./components/molecules/imageCard/ImageCard.jsx








var ImageCard = function ImageCard(_ref) {
  var image = _ref.image,
      type = _ref.type,
      icon = _ref.icon,
      title = _ref.title,
      description = _ref.description,
      ctaLabel = _ref.ctaLabel,
      ctaLink = _ref.ctaLink,
      ctaVariant = _ref.ctaVariant,
      id = _ref.id,
      dataCMSTitle = _ref.dataCMSTitle,
      _ref$analyticsData = _ref.analyticsData,
      analyticsData = _ref$analyticsData === void 0 ? {} : _ref$analyticsData,
      isOpenNewTab = _ref.isOpenNewTab;
  var router = (0,DependencyHelper.useRouter)();

  var handleClick = function handleClick() {
    analyticsUtag/* link */.p4(analyticsData);
  };

  var isMobile = (0,helperServices/* componentResize */.Y4)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      backgroundImage: "url(".concat(image, ")")
    },
    className: "".concat((imageCard_module_default())["card-container"], " ").concat((imageCard_module_default())[type]),
    id: id,
    "data-cms-title": dataCMSTitle.toLowerCase(),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (imageCard_module_default())["card-info"],
      children: [icon && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: icon,
        className: (imageCard_module_default())["card-icon"]
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (imageCard_module_default())["card-title"],
        children: title
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (imageCard_module_default())["card-heading"],
        dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(description)
      }), ctaLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (imageCard_module_default())["card-button"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
          variant: ctaVariant,
          id: "".concat(id, "_CTABtn"),
          url: ctaLink,
          className: "".concat(isMobile ? "pl-s pr-s" : "pl-m pr-m", " ").concat((imageCard_module_default())["custom-style"], " "),
          handleClick: handleClick,
          isOpenNewTab: isOpenNewTab,
          children: ctaLabel
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (imageCard_module_default())["card-gradient"]
    })]
  });
};

/* harmony default export */ var imageCard_ImageCard = (ImageCard);
// EXTERNAL MODULE: ./components/molecules/specialProduct/specialProduct.module.scss
var specialProduct_module = __webpack_require__(86539);
var specialProduct_module_default = /*#__PURE__*/__webpack_require__.n(specialProduct_module);
// EXTERNAL MODULE: ./components/molecules/hotSpot/HotSpot.jsx
var HotSpot = __webpack_require__(92267);
// EXTERNAL MODULE: ./components/atoms/tag/Tag.jsx
var Tag = __webpack_require__(4648);
;// CONCATENATED MODULE: ./components/molecules/specialProduct/SpecialProduct.jsx









var SpecialProduct = function SpecialProduct(props) {
  var router = (0,DependencyHelper.useRouter)();

  var handleClick = function handleClick() {
    (0,helperServices/* goToUrl */.tt)(props.ctaLink, router);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((specialProduct_module_default()).card, " ").concat(props.className),
    id: props.id,
    "data-cms-title": props["data-cms-title"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (specialProduct_module_default()).card__media,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HotSpot/* default */.Z, {
        imgUrl: props.imgUrl,
        dataPoints: props.hotSpots
      }), props.tagLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
        variant: props.tagVariant,
        className: (specialProduct_module_default()).tag,
        label: props.tagLabel
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (specialProduct_module_default())["card-bottom-container"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (specialProduct_module_default()).card__body,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (specialProduct_module_default()).card__title,
          children: props.heading
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (specialProduct_module_default()).card__description,
          dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(props.description)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (specialProduct_module_default()).card__label,
          children: props.additionals
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (specialProduct_module_default()).card__footer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: (specialProduct_module_default()).card__price,
            children: [props.price, " "]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-right ml-xs",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
            className: "".concat((specialProduct_module_default()).card__cta1),
            url: props.ctaLink,
            variant: props.variant,
            id: "".concat(props.id, "_CTABtn"),
            isOpenNewTab: props === null || props === void 0 ? void 0 : props.isOpenNewTab,
            children: props.ctaLabel
          })
        })]
      })]
    })]
  });
};

SpecialProduct.defaultProps = {
  type: "image",
  className: "",
  variant: ""
};
/* harmony default export */ var specialProduct_SpecialProduct = (SpecialProduct);
// EXTERNAL MODULE: ./components/molecules/homeSlider/homeSlider.module.scss
var homeSlider_module = __webpack_require__(14337);
var homeSlider_module_default = /*#__PURE__*/__webpack_require__.n(homeSlider_module);
;// CONCATENATED MODULE: ./components/molecules/homeSlider/HomeSlider.jsx








var HomeSlider = function HomeSlider(props) {
  var cardCarousel;
  var isMobile = (0,helperServices/* componentResize */.Y4)();

  var _useState = (0,react.useState)(""),
      previousNavClass = _useState[0],
      setPreviousNavClass = _useState[1];

  var _useState2 = (0,react.useState)(""),
      nextNavClass = _useState2[0],
      setNextNavClass = _useState2[1];

  var isTwoThird = props.type === "two-third";

  var next = function next() {
    if (cardCarousel) {
      cardCarousel.next(600);
    }
  };

  var prev = function prev() {
    if (cardCarousel) {
      cardCarousel.prev(600);
    }
  };

  var carouselOptions = {
    nav: true,
    autoplay: false,
    animateIn: "animate__fadeIn",
    autoWidth: true,
    lazyLoad: true,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots",
    dotClass: "owl--dot",
    slideBy: 1,
    margin: 16,
    responsive: {
      0: {
        dots: true,
        // mouseDrag: false,
        // touchDrag: true,
        items: 1
      },
      1024: {
        dots: false,
        mouseDrag: false,
        touchDrag: true
      }
    }
  };
  var events = {
    onInitialized: function onInitialized(event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslate: function onTranslate(event) {
      setCarouselLeftMargin(event);
    },
    onTranslated: function onTranslated(event) {
      toggleCarouselNavDisabled(event);
    },
    onDragged: function onDragged(event) {
      var ele = document.getElementById("tooltip-0"); // var checkTheme = document.getElementsByClassName("owl-theme");
      // var homeSliderElm = document.getElementsByClassName("homeSlider_home-slider__1vSER");
      // var undefinedElm = document.getElementsByClassName("undefined");
      // if(homeSliderElm) {
      //   for (let elm of homeSliderElm) {
      //     elm.classList.remove("homeSlider_home-slider__1vSER");
      //   }
      // }
      // if(checkTheme) {
      //   for (let item of checkTheme) {
      //     item.classList.add("owl-drag");
      //   }
      // }
      // if(undefinedElm) {
      //   for (let elm of undefinedElm) {
      //     elm.classList.remove("undefined");
      //   }
      // }

      if (ele) {
        // Temp hot fix
        ele.classList.remove("show");
        ele.classList.add("hide");
      }
    }
  };

  function setCarouselLeftMargin(event) {
    var index = event.item.index;
    var maximum = event.item.count;
    var leftShift = "0px";

    if (!isMobile) {
      if (isTwoThird) {
        leftShift = index + 2 >= maximum ? "95px" : "0px";
      } else {
        leftShift = index + 3 >= maximum ? "20px" : "0px";
      }
    }

    event.target.style.paddingLeft = leftShift;
  }

  function toggleCarouselNavDisabled(event) {
    var index = event.item.index;
    var minimum = 0;
    var maximum = event.item.count;
    var previousNav = index <= minimum ? "disabled" : "";
    var nextNav;

    if (isMobile) {
      nextNav = index + 1 >= maximum ? "disabled" : "";
    } else {
      if (isTwoThird) {
        nextNav = index + 2 >= maximum ? "disabled" : "";
      } else {
        nextNav = index + 3 >= maximum ? "disabled" : "";
      }
    }

    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((homeSlider_module_default())["home-slider"], " ").concat(props === null || props === void 0 ? void 0 : props.className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: isMobile ? "container-fluid p-0" : "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "owl-carousel-wrapper home-carousel",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.OwlCarousel, {
          ref: function ref(c) {
            return cardCarousel = c;
          },
          options: carouselOptions,
          events: events,
          children: props.slideItems.map(function (owlItem, index, array) {
            return props.children(owlItem, index, array, props.type);
          })
        })
      })
    }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "custom-owl--nav",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CarouselButton/* default */.Z, {
        prev: true,
        handleClick: prev,
        className: previousNavClass,
        id: "HomeSlider_arrowBackBtn"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselButton/* default */.Z, {
        next: true,
        handleClick: next,
        className: nextNavClass,
        id: "HomeSlider_arrowNextBtn"
      })]
    })]
  });
};

HomeSlider.defaultProps = {
  type: "default",
  slideItems: []
};
/* harmony default export */ var homeSlider_HomeSlider = (HomeSlider);
// EXTERNAL MODULE: ./components/atoms/pageHeading/PageHeading.jsx
var PageHeading = __webpack_require__(19456);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./components/organisms/stepProcess/StepProcess.module.scss
var StepProcess_module = __webpack_require__(38588);
var StepProcess_module_default = /*#__PURE__*/__webpack_require__.n(StepProcess_module);
;// CONCATENATED MODULE: ./components/organisms/stepProcess/StepProcess.jsx











var StepProcess = function StepProcess(_ref) {
  var className = _ref.className,
      metaData = _ref.metaData;
  var imageType = metaData && metaData.items && metaData.items[0].imageStyle;

  var _useState = (0,react.useState)(metaData === null || metaData === void 0 ? void 0 : metaData.items[0]),
      activeStep = _useState[0],
      setActiveStep = _useState[1];

  var _useState2 = (0,react.useState)(""),
      previousNavClass = _useState2[0],
      setPreviousNavClass = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      nextNavClass = _useState3[0],
      setNextNavClass = _useState3[1];

  var options = {
    items: 1,
    nav: true,
    autoplay: false,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots owl--dots--show",
    dotClass: "owl--dot owl--dot--l owl--dot--red",
    animateIn: "animate__fadeIn",
    responsive: {
      0: {
        slideBy: 1
      }
    }
  };
  var carousel;

  var next = function next() {
    if (carousel) {
      carousel.next(600);
    }
  };

  var prev = function prev() {
    if (carousel) {
      carousel.prev(600);
    }
  };

  var events = {
    onInitialized: function onInitialized(event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function onTranslated(event) {
      toggleCarouselNavDisabled(event);
    }
  };

  function toggleCarouselNavDisabled(event) {
    var index = event.item.index;
    var minimum = 0;
    var maximum = event.item.count;
    var previousNav = index <= minimum ? "disabled" : "";
    var nextNav = index + options.responsive[event.relatedTarget._breakpoint].slideBy >= maximum ? "disabled" : "";
    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  var StepContent = function StepContent(_ref2) {
    var step = _ref2.step,
        checkActive = _ref2.checkActive,
        onClickHandler = _ref2.onClickHandler,
        index = _ref2.index;

    var onClick = function onClick() {
      if (onClickHandler) {
        onClickHandler(step);
      }
    };

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (StepProcess_module_default())["process-container"],
      onClick: onClick,
      id: step.id,
      "data-cms-title": step.analyticTitle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (StepProcess_module_default())["process-number"],
        children: ["0", index + 1]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (StepProcess_module_default())["process-details"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Text, {
          className: "".concat((StepProcess_module_default())["process-heading"], "  ").concat((StepProcess_module_default())[checkActive ? activeStep.id === step.id ? "active-text" : "inactive-text" : "active-text"]),
          children: step === null || step === void 0 ? void 0 : step.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((StepProcess_module_default())["process-description"], " ").concat((StepProcess_module_default())[checkActive ? activeStep.id === step.id ? "active-text" : "inactive-text" : "active-text"]),
          dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(step === null || step === void 0 ? void 0 : step.description)
        }), checkActive && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "pr-s d-none d-md-block ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Progress, {
            className: (StepProcess_module_default())[activeStep.id === step.id ? "progress-container" : "inactive-progessbar"],
            max: metaData.items && metaData.items.length,
            min: 0,
            value: index + 1
          })
        })]
      })]
    }, step.id);
  };

  var MobileContent = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "owl-wrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.OwlCarousel, {
        ref: function ref(c) {
          return carousel = c;
        },
        options: options,
        events: events,
        children: metaData === null || metaData === void 0 ? void 0 : metaData.items.map(function (step, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
            noGutters: true,
            className: "".concat(className).concat((StepProcess_module_default())["mobile-container"]),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
              xs: 12,
              className: "".concat((StepProcess_module_default())["top-col"]),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                style: {
                  backgroundImage: "url(" + (step === null || step === void 0 ? void 0 : step.image) + ")"
                },
                className: imageType === "Landscape Image" ? (StepProcess_module_default())["image-container-landscape"] : (StepProcess_module_default())["image-container-square"]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
              xs: 12,
              className: "".concat((StepProcess_module_default())["bottom-col"]),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
                text: metaData === null || metaData === void 0 ? void 0 : metaData.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(StepContent, {
                step: step,
                index: index
              }, step.id)]
            })]
          }, step.id);
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "custom-owl--nav ".concat((StepProcess_module_default())["custom-container-button"]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CarouselButton/* default */.Z, {
        prev: true,
        className: "".concat((StepProcess_module_default())["prev-btn"], " ").concat(previousNavClass),
        handleClick: prev,
        variant: "oval",
        btnSize: "sm",
        id: "StepProcess_arrowBackBtn"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselButton/* default */.Z, {
        next: true,
        className: "".concat((StepProcess_module_default())["next-btn"], " ").concat(nextNavClass),
        handleClick: next,
        variant: "oval",
        btnSize: "sm",
        id: "StepProcess_arrowNextBtn"
      })]
    })]
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
      className: "".concat(className, " d-none d-lg-flex"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
        md: 6,
        className: "".concat((StepProcess_module_default())["bottom-col"], " pr-3"),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
          text: metaData === null || metaData === void 0 ? void 0 : metaData.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (StepProcess_module_default())["process-steps"],
          children: metaData === null || metaData === void 0 ? void 0 : metaData.items.map(function (step, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(StepContent, {
              step: step,
              checkActive: true,
              onClickHandler: setActiveStep,
              index: index
            }, step.id);
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
        md: 6,
        className: "".concat((StepProcess_module_default())[imageType != "Landscape Image" && "top-col"], " order-md-last pl-3"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: activeStep.image,
          className: imageType === "Landscape Image" ? (StepProcess_module_default())["image-landscape"] : (StepProcess_module_default())["image-square"]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "d-block d-lg-none position-relative",
      children: MobileContent
    })]
  });
};

StepProcess.defaultProps = {
  metaData: {},
  className: ""
};
/* harmony default export */ var stepProcess_StepProcess = (StepProcess);
// EXTERNAL MODULE: ./components/molecules/SmallCardsCarousel/SmallCardsCarousel.module.scss
var SmallCardsCarousel_module = __webpack_require__(45159);
var SmallCardsCarousel_module_default = /*#__PURE__*/__webpack_require__.n(SmallCardsCarousel_module);
;// CONCATENATED MODULE: ./components/molecules/SmallCardsCarousel/SmallCardsCarousel.jsx


function SmallCardsCarousel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SmallCardsCarousel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SmallCardsCarousel_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SmallCardsCarousel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var SmallCardsCarousel = function SmallCardsCarousel(props) {
  var _props$data3, _props$data4;

  var _useState = (0,react.useState)(""),
      previousNavClass = _useState[0],
      setPreviousNavClass = _useState[1];

  var _useState2 = (0,react.useState)(""),
      nextNavClass = _useState2[0],
      setNextNavClass = _useState2[1];

  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() <= 768;
  var sizeCheck = (0,helperServices/* componentResize */.Y4)();
  var data = props.data.cards;
  var cardCarousel;

  var next = function next() {
    if (cardCarousel) {
      cardCarousel.next(600);
    }
  };

  var prev = function prev() {
    if (cardCarousel) {
      cardCarousel.prev(600);
    }
  };

  var carouselOptions = {
    nav: true,
    autoplay: false,
    animateIn: "animate__fadeIn",
    autoWidth: true,
    lazyLoad: true,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots",
    dotClass: "owl--dot--small",
    margin: isMobile ? 8 : 16,
    responsive: {
      0: {
        dots: true,
        slideBy: 1,
        mouseDrag: true,
        touchDrag: true
      },
      768: {
        dots: true,
        slideBy: 3
      },
      1024: {
        dots: false
      },
      1200: {
        slideBy: 2
      },
      1440: {
        slideBy: 3
      }
    }
  };
  var events = {
    onInitialized: function onInitialized(event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslate: function onTranslate(event) {
      setCarouselLeftMargin(event);
    },
    onTranslated: function onTranslated(event) {
      toggleCarouselNavDisabled(event);
    }
  };

  function setCarouselLeftMargin(event) {
    var index = event.item.index;
    var maximum = event.item.count;
    var leftShift = "0px";

    if (!isMobile) {
      leftShift = index + carouselOptions.responsive[event.relatedTarget._breakpoint].slideBy >= maximum ? "23px" : "0px";
    }

    event.target.style.paddingLeft = leftShift;
  }

  function toggleCarouselNavDisabled(event) {
    var index = event.item.index;
    var minimum = 0;
    var maximum = event.item.count;
    var previousNav = index <= minimum ? "disabled" : "";
    var nextNav = index + carouselOptions.responsive[event.relatedTarget._breakpoint].slideBy >= maximum ? "disabled" : "";
    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  var router = (0,DependencyHelper.useRouter)();

  var handleClick = function handleClick(item, index) {
    var _props$analyticsData, _props$data, _props$data2;

    // let url = item?.url || item?.link;
    // if (url.includes("internal:")) {
    //   url = url.split("internal:")[1];
    // }
    // goToUrl(url, router);
    analyticsUtag/* link */.p4(SmallCardsCarousel_objectSpread(SmallCardsCarousel_objectSpread({}, props.analyticsData), {}, {
      link_name: "".concat((_props$analyticsData = props.analyticsData) === null || _props$analyticsData === void 0 ? void 0 : _props$analyticsData.page_name, ": small: p").concat(index + 1, ": ").concat(props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.componentTitle, ": ").concat(props === null || props === void 0 ? void 0 : (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.cardType, ": ").concat(item.name)
    }));
  };

  var generateAlignment = function generateAlignment() {
    switch (props === null || props === void 0 ? void 0 : props.data.heading_position) {
      case "left":
      case "LEFT":
        {
          return props !== null && props !== void 0 && props.data.heading_position ? "justify-content-start text-left" : "";
        }

      case "right":
      case "RIGHT":
        {
          return props !== null && props !== void 0 && props.data.heading_position ? "justify-content-end text-right" : "";
        }

      case "center":
      case "CENTER":
        {
          return props !== null && props !== void 0 && props.data.heading_position ? "text-center" : "";
        }

      default:
        return "text-left";
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    id: "".concat(props.data.id, "-smallCards"),
    className: "".concat((SmallCardsCarousel_module_default())["small-cards-carousel-container"], " small-card "),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        id: "".concat(props.data.id, "-smallCards-head"),
        className: "".concat((SmallCardsCarousel_module_default())[props.smallTitle ? "small-title" : "smallcards-title"], " ").concat(generateAlignment()),
        children: ((_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : _props$data3.componentTitle) || ((_props$data4 = props.data) === null || _props$data4 === void 0 ? void 0 : _props$data4.title)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: isMobile ? "container-fluid p-0" : "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "owl-carousel-wrapper__small home-carousel  ",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.OwlCarousel, {
          ref: function ref(c) {
            return cardCarousel = c;
          },
          options: carouselOptions,
          events: events,
          children: data.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Link, {
              legacyBehavior: true,
              href: (0,helperServices/* internalUrl */.az)(item.url || item.link).url,
              prefetch: item.isOpenNewTab && item.isOpenNewTab === "1" ? false : (0,helperServices/* internalUrl */.az)(item.url || item.link).internal,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                onClick: function onClick() {
                  return handleClick(item, index);
                },
                target: item.isOpenNewTab && item.isOpenNewTab === "1" ? "_blank" : "_self",
                style: {
                  backgroundImage: "url(".concat(item.image, ")"),
                  width: isMobile ? props.mobile_width ? props.mobile_width : props.width : props.width,
                  height: isMobile ? props.mobile_height ? props.mobile_height : props.height : props.height
                },
                className: (SmallCardsCarousel_module_default())["image-container"],
                id: "".concat(item.id, "-smallCards"),
                "data-cms-title": item.analyticTitle,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                  className: (SmallCardsCarousel_module_default())["image-container__content"],
                  children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                    className: "".concat((SmallCardsCarousel_module_default())["image-container__logo"], " ").concat((SmallCardsCarousel_module_default())[props.data.cardType === "Brand" ? "logo" : "icon"]),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                      src: item.icon,
                      className: (SmallCardsCarousel_module_default()).image,
                      id: "".concat(item === null || item === void 0 ? void 0 : item.name, "-brand-icon")
                    })
                  }), (item === null || item === void 0 ? void 0 : item.name) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                    className: (SmallCardsCarousel_module_default())["image-container__category-name"],
                    children: item.name
                  }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                    className: (SmallCardsCarousel_module_default())["image-container__title"],
                    id: "".concat(item.title, "-banner"),
                    children: item.title
                  }), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                    className: (SmallCardsCarousel_module_default())["image-container__description"],
                    dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(item.description),
                    id: "".concat(item.title, "-desc-banner")
                  })]
                })
              }, item.id)
            }, "carousel-link-".concat(index));
          })
        })
      })
    }), !props.hideCarousel && !sizeCheck && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "custom-owl--nav",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CarouselButton/* default */.Z, {
        prev: true,
        variant: "small-carousel",
        handleClick: prev,
        className: previousNavClass,
        id: "SmallCardCarousel_arrowBackBtn"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselButton/* default */.Z, {
        next: true,
        handleClick: next,
        variant: "small-carousel",
        className: nextNavClass,
        id: "SmallSCardCarousel_arrowNextBtn"
      })]
    })]
  });
};

/* harmony default export */ var SmallCardsCarousel_SmallCardsCarousel = (SmallCardsCarousel);
// EXTERNAL MODULE: ./components/organisms/FourQuadInteractive/FourQuadInteractive.module.scss
var FourQuadInteractive_module = __webpack_require__(4127);
var FourQuadInteractive_module_default = /*#__PURE__*/__webpack_require__.n(FourQuadInteractive_module);
// EXTERNAL MODULE: ./components/molecules/proposition/Proposition.module.scss
var Proposition_module = __webpack_require__(64479);
var Proposition_module_default = /*#__PURE__*/__webpack_require__.n(Proposition_module);
// EXTERNAL MODULE: ./components/atoms/divider/Divider.jsx
var Divider = __webpack_require__(22009);
// EXTERNAL MODULE: ./components/atoms/text/Text.jsx
var Text = __webpack_require__(72786);
;// CONCATENATED MODULE: ./components/molecules/proposition/Proposition.jsx









var Proposition = function Proposition(_ref) {
  var align = _ref.align,
      onClick = _ref.onClick,
      isActive = _ref.isActive,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      showIcon = _ref.showIcon,
      isStatic = _ref.isStatic;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
    className: "\n      ".concat((Proposition_module_default()).proposition, "\n      ").concat(align === "right" ? "align-items-end" : "align-items-start", "\n      ").concat(isActive && (Proposition_module_default())["proposition--active"], "\n      ").concat(isStatic && (Proposition_module_default())["proposition--static"], "\n      "),
    onClick: onClick,
    id: data.id,
    "data-cms-title": data.analyticTitle,
    children: [showIcon && data.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
      img_path: data.icon,
      className: (Proposition_module_default()).proposition__icon
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text.H4, {
      color: "inherit",
      textAlign: align,
      width: "100%",
      fontFamily: "'Roboto Bold', Arial, Helvetica, sans-serif",
      className: (Proposition_module_default()).proposition__title,
      children: data.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "d-flex p-0 ".concat(align === "right" ? "justify-content-end" : "justify-content-start"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* HorizontalLine */.f, {
        className: (Proposition_module_default()).proposition__divider,
        width: "3rem"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Body */.u, {
      dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(data.description),
      color: "inherit",
      textAlign: align,
      lineHeight: "1.5",
      width: "100%",
      fontFamily: "'Roboto Regular', Arial, Helvetica, sans-serif"
    })]
  });
};

Proposition.defaultProps = {
  data: {
    icon: null,
    heading: null,
    description: null
  },
  showIcon: true
};
/* harmony default export */ var proposition_Proposition = (Proposition);
// EXTERNAL MODULE: ./components/molecules/carousel/Carousel.jsx
var Carousel = __webpack_require__(59312);
;// CONCATENATED MODULE: ./components/organisms/FourQuadInteractive/FourQuadInteractive.jsx












var FourQuadInteractive = function FourQuadInteractive(_ref) {
  var content = _ref.content,
      data = _ref.data;

  var _useState = (0,react.useState)(0),
      indexActive = _useState[0],
      setIndexActive = _useState[1];

  var _useState2 = (0,react.useState)(content[indexActive].image),
      activeImage = _useState2[0],
      setActiveImage = _useState2[1];

  var _useState3 = (0,react.useState)({
    left: [],
    right: []
  }),
      quadrants = _useState3[0],
      setQuadrants = _useState3[1];

  var handleOnClick = function handleOnClick(index) {
    if (index !== indexActive) {
      setIndexActive(index);
    }
  };

  var buildQuadrant = function buildQuadrant(index, isActive, item, align) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(proposition_Proposition, {
      data: item,
      onClick: function onClick() {
        return handleOnClick(index);
      },
      align: align,
      isActive: isActive,
      isStatic: data.staticImage
    });
  };

  var buildQuadrants = function buildQuadrants(items) {
    var quadrantsLeft = [];
    var quadrantsRight = [];
    items.map(function (item, index) {
      var isActive = data.staticImage ? true : index === indexActive;

      if (index % 2 === 0) {
        quadrantsLeft.push( /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          children: buildQuadrant(index, isActive, item, "right", true)
        }, index));
      } else {
        quadrantsRight.push( /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          children: buildQuadrant(index, isActive, item, "left", true)
        }, index));
      }

      setQuadrants({
        left: quadrantsLeft,
        right: quadrantsRight
      });
    });
  };

  (0,react.useEffect)(function () {
    buildQuadrants(content);
    setActiveImage(content[indexActive].image);
  }, [indexActive]);

  var generateAlignment = function generateAlignment() {
    switch (data === null || data === void 0 ? void 0 : data.heading_position) {
      case "left":
      case "LEFT":
        {
          return data !== null && data !== void 0 && data.heading_position ? "text-left" : "";
        }

      case "right":
      case "RIGHT":
        {
          return data !== null && data !== void 0 && data.heading_position ? "text-right" : "";
        }

      default:
        return "text-center";
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
        text: data.componentTitle,
        className: "".concat((FourQuadInteractive_module_default())["main-heading"], " ").concat(generateAlignment(), " ")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
        text: data.componentHeading,
        className: "".concat((FourQuadInteractive_module_default()).heading, " ").concat(generateAlignment(), " ")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
        level: 4,
        text: data.componentDescription,
        className: "".concat((FourQuadInteractive_module_default())["main-description"], " d-flex ").concat(generateAlignment(), " ")
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
        className: "d-none d-lg-flex align-items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
            md: 1,
            className: (FourQuadInteractive_module_default()).quadrant,
            children: quadrants.left
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          md: "auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
            className: (FourQuadInteractive_module_default())["quadrant-image-container"],
            style: {
              backgroundImage: "url(".concat(data.staticImage ? data.staticImage : activeImage, ")")
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
            md: 1,
            className: (FourQuadInteractive_module_default()).quadrant,
            children: quadrants.right
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
      bsPrefix: (FourQuadInteractive_module_default())["container-mobile"],
      className: "d-lg-none",
      children: [data.staticImage && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "d-flex justify-content-center ".concat((FourQuadInteractive_module_default())["quadrant-mobile "]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: data === null || data === void 0 ? void 0 : data.staticImage,
          className: (FourQuadInteractive_module_default())["quadrant-image"]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel/* default */.Z, {
        showNav: true,
        navClassName: "".concat((FourQuadInteractive_module_default())["carousel-nav"], " ").concat((FourQuadInteractive_module_default())[data.staticImage && "carousel-nav--static"]),
        children: content.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
            bsPrefix: (FourQuadInteractive_module_default())["carousel-container"],
            className: "d-flex flex-column justify-content-center",
            children: [!data.staticImage && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "d-flex justify-content-center ",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
                img_path: item.image,
                className: (FourQuadInteractive_module_default())["quadrant-image"]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "".concat((FourQuadInteractive_module_default())[!data.staticImage && "quadrant-mobile"]),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(proposition_Proposition, {
                data: item,
                align: "left",
                isActive: true,
                showIcon: false
              })
            })]
          }, index);
        })
      })]
    })]
  });
};

/* harmony default export */ var FourQuadInteractive_FourQuadInteractive = (FourQuadInteractive);
// EXTERNAL MODULE: ./config/index.js
var config_0 = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config_0);
;// CONCATENATED MODULE: ./services/renderComponent.js


function renderComponent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function renderComponent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? renderComponent_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : renderComponent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var VideoBanner = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2544), __webpack_require__.e(7201), __webpack_require__.e(8764), __webpack_require__.e(7616)]).then(__webpack_require__.bind(__webpack_require__, 26484));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26484)];
    }
  }
});
var AppBanner = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9611).then(__webpack_require__.bind(__webpack_require__, 29611));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(29611)];
    }
  }
});
var UspContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7228).then(__webpack_require__.bind(__webpack_require__, 97228));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(97228)];
    }
  }
});
var HomeBanner = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9082).then(__webpack_require__.bind(__webpack_require__, 49082));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(49082)];
    }
  }
});
var PromotionBanner = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 8058).then(__webpack_require__.bind(__webpack_require__, 68058));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(68058)];
    }
  }
});
var TestimonialCarousel = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7866).then(__webpack_require__.bind(__webpack_require__, 17866));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(17866)];
    }
  }
});
var TwoColumnImage = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5724).then(__webpack_require__.bind(__webpack_require__, 65724));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(65724)];
    }
  }
});
var MultiLayoutProposition = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6434).then(__webpack_require__.bind(__webpack_require__, 36434));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(36434)];
    }
  }
});
var NumericCounter = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2616).then(__webpack_require__.bind(__webpack_require__, 52616));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(52616)];
    }
  }
});
var AccordionContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7261).then(__webpack_require__.bind(__webpack_require__, 47261));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(47261)];
    }
  }
});
var ServiceCardGroup = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9597).then(__webpack_require__.bind(__webpack_require__, 69597));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69597)];
    }
  }
});
var CountDownBanner = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5848).then(__webpack_require__.bind(__webpack_require__, 85848));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(85848)];
    }
  }
});
var InternationalCallingDropdown = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7320).then(__webpack_require__.bind(__webpack_require__, 97320));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(97320)];
    }
  }
});
var InfoContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4684).then(__webpack_require__.bind(__webpack_require__, 84684));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(84684)];
    }
  }
});
var PanoramaImage = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6703).then(__webpack_require__.bind(__webpack_require__, 26703));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26703)];
    }
  }
});
var BreadCrumb = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2426).then(__webpack_require__.bind(__webpack_require__, 55120));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(55120)];
    }
  }
});
var FibreSearchBanner = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 86).then(__webpack_require__.bind(__webpack_require__, 60086));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(60086)];
    }
  }
});
var QuickLink = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 334).then(__webpack_require__.bind(__webpack_require__, 334));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(334)];
    }
  }
});

















var renderComponent = function renderComponent(component, key) {
  var analyticsData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var toRender;

  switch (component.type) {
    case "breadcrumbs":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          id: component.id,
          fluid: true,
          "data-cms-title": component.analyticTitle,
          className: " ".concat(component.title == "International calling breadcrumb" && "container-roaming"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb, {
              list: (0,helperServices/* formatBreadCrumb */.x9)(component.items)
            })
          })
        }, component.type + key);
        break;
      }

    case "multi_column_usp":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
          id: component.id,
          "data-cms-title": component.analyticTitle,
          className: "py-l",
          fluid: true,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
            secondaryGreyText: component.title,
            alignment: component === null || component === void 0 ? void 0 : component.heading_position,
            container: true,
            titleType: component.titleType
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(UspContainer, {
            uspItems: component
          })]
        }, component.type + key);
        break;
      }

    case "deal_catalog":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          fluid: true,
          className: "py-l",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DealCatalog_DealCatalog, {
            component: component,
            analyticsData: analyticsData,
            campaignFlag: true
          })
        }, component.type + key);
        break;
      }

    case "product_catalog":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          fluid: true,
          className: "py-l",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(productCatalog_ProductCatalog, {
            component: component,
            analyticsData: analyticsData
          })
        }, component.type + key);
        break;
      }

    case "carousel":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          fluid: true,
          className: "overflow-hidden",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeroCarousel/* default */.Z, {
            slides: component.items,
            btnVariant: component.buttonStyle,
            carouselBtnVariant: component === null || component === void 0 ? void 0 : component.carouselButtonStyle,
            id: component.id
          })
        }, component.type + key);
        break;
      }

    case "portlet":
      {
        toRender = renderPortlet(component, key);
        break;
      }

    case "product_card":
    case "image_card":
      {
        toRender = imageCardSlider(component, key, analyticsData);
        break;
      }

    case "four_column_usp":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
            secondaryGreyText: component.title,
            alignment: component === null || component === void 0 ? void 0 : component.heading_position,
            container: true
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(UspContainer, {
            uspItems: component
          })]
        }, component.type + key);
        break;
      }

    case "banner":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
          fluid: true,
          className: "py-l overflow-hidden px-0",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
            text: component.bannerTitle,
            secondaryText: component.bannerSubTitle,
            mainHeadingRequired: true,
            alignment: component === null || component === void 0 ? void 0 : component.heading_position,
            container: true
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(HomeBanner, {
            desktopImage: component.bannerImage,
            mobileImage: component.bannerMobileImage,
            ctaLabel: component.callToActionLabel,
            ctaLink: component.callToActionUrl,
            btnVariant: component.buttonStyle,
            isOpenNewTab: component.isOpenNewTab,
            id: component.id ? component.id : ""
          })]
        }, component.type + key);
        break;
      }

    case "appstore_banner":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
          className: "py-l overflow-hidden",
          fluid: true,
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
            text: component.title,
            secondaryText: component.heading,
            mainHeadingRequired: true,
            alignment: component === null || component === void 0 ? void 0 : component.heading_position
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(AppBanner, {
            icon: component.icon,
            description: component.description,
            buttons: component.buttonItems,
            desktopImage: component.backgroundImage,
            mobileImage: component.backgroundImageMobile,
            imageApp: component.image,
            buttonsVariant: component.buttonStyle,
            imageMobile: component.imageMobile ? component.imageMobile : ""
          })]
        }, component.type + key);
        break;
      }

    case "horizontal_video":
    case "video_with_cta":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
          className: "py-l",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
            text: component.title,
            secondaryText: component.description,
            mainHeadingRequired: true,
            alignment: component === null || component === void 0 ? void 0 : component.heading_position
          }), renderVideo(component, true)]
        }, component.type + key);
        break;
      }

    case "promotion_container":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          fluid: true,
          className: "promotion_container",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PromotionBanner, {
            metaData: component,
            variant: "roaming"
          })
        }, component.type + key);
        break;
      }

    case "multi_column_card":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          className: "py-l px-0",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          fluid: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceCardGroup, {
            alignment: component === null || component === void 0 ? void 0 : component.heading_position,
            cards: component.items,
            cardType: "service",
            heading: component.title,
            className: "justify-content-center"
          })
        }, component.type + key);
        break;
      }

    case "3_column_plain_cards":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          className: "py-l",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          fluid: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceCardGroup, {
            cards: component.cards,
            cardType: "plain",
            heading: component.componentTitle,
            customStyle: true
          })
        }, component.type + key);
        break;
      }

    case "paragraph":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          className: "pt-l pb-xs container pt-32",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoContainer, {
            component: component
          })
        }, component.type + key);
        break;
      }

    case "two_column_proposition":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          className: "py-l",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TwoColumnImage, {
            metaData: component
          })
        }, component.type + key);
        break;
      }

    case "calling_costs":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          id: component.id,
          "data-cms-title": component.analyticTitle,
          className: "pb-l",
          fluid: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(InternationalCallingDropdown, {
            data: component
          })
        }, component.type + key);
        break;
      }

    case "numerical_counter":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
            secondaryText: component.title,
            alignment: component === null || component === void 0 ? void 0 : component.heading_position
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(NumericCounter, {
            numericCounterData: component
          })]
        }, component.type + key);
        break;
      }

    case "countdown_banner":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          id: component.id,
          fluid: true,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CountDownBanner, {
            countDownBannerData: component
          })
        }, component.type + key);
        break;
      }

    case "check_coverage_banner":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          id: component.id,
          fluid: true,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FibreSearchBanner, {
            fibreSearchBannerData: component
          })
        }, component.type + key);
        break;
      }

    case "quicklinks":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          id: component.id,
          fluid: true,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLink, {
            quickLinkData: component
          })
        }, component.type + key);
        break;
      }

    case "testimonial_carousel":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          className: "py-l overflow-hidden",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TestimonialCarousel, {
            items: component.items
          })
        }, component.type + key);
        break;
      }

    case "multi_column_proposition":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          className: "py-l",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          fluid: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MultiLayoutProposition, {
            metaData: component
          })
        }, component.type + key);
        break;
      }

    case "multi_quadrant_proposition":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          id: component.id,
          className: "py-l",
          "data-cms-title": component.analyticTitle,
          fluid: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MultiLayoutProposition, {
            metaData: component
          })
        }, component.type + key);
        break;
      }

    case "product_carousel":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCarousel/* default */.Z, {
          ProductCarouselData: component.products,
          id: component.id,
          "data-cms-title": component.analyticTitle,
          width: "15.5rem",
          img_width: "11.25rem",
          img_height: "11.25rem",
          width_mobile: "10.375rem",
          img_width_mobile: "8.375rem",
          img_height_mobile: "8.375rem"
        }, component.type + key);
        break;
      }

    case "accordion":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          id: component.id,
          "data-cms-title": component.analyticTitle,
          className: "py-l",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionContainer, {
            faqSections: component.faqs,
            componentTitle: component.componentTitle,
            componentDescription: component.componentDescription,
            alignment: component === null || component === void 0 ? void 0 : component.heading_position
          })
        }, component.type + key);
        break;
      }

    case "123_process_image":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          className: "py-l",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(stepProcess_StepProcess, {
            metaData: component
          })
        }, component.type + key);
        break;
      }

    case "multi_quadrant_phone_visual":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "py-l",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FourQuadInteractive_FourQuadInteractive, {
            content: component.items,
            data: component
          })
        }, component.type + key);
        break;
      }

    case "panoramic_image":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PanoramaImage, {
            data: component
          })
        }, component.type + key);
        break;
      }

    case "small_card_image_carousel":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "py-l",
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SmallCardsCarousel_SmallCardsCarousel, {
            data: component,
            type: component.type,
            width: "100%",
            height: "11.25rem",
            mobile_width: "18.5625rem",
            mobile_height: "11.25rem",
            analyticsData: renderComponent_objectSpread({
              link_type: "o"
            }, analyticsData)
          })
        }, component.type + key);
        break;
      }

    case "grid_carousel":
      {
        toRender = /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          id: component.id,
          "data-cms-title": component.analyticTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SmallCardsCarousel_SmallCardsCarousel, {
            data: component,
            type: component.type,
            width: "100%",
            height: "15rem",
            mobile_width: "19.6875rem",
            mobile_height: "12.5rem",
            hideCarousel: true,
            smallTitle: true
          })
        }, component.type + key);
        break;
      }

    default:
      console.log("could not render component", component.type);
  }

  return toRender;
};
var renderPortlet = function renderPortlet(component, key) {
  var tabs = Object.keys(component.items);
  var totalTabs = tabs.length;

  var generateHotSpot = function generateHotSpot(left, top, heading, description, placement) {
    if (left && top && placement) {
      return [{
        tip: {
          placement: placement,
          heading: heading,
          description: description
        },
        left: left,
        top: top
      }];
    }

    return [];
  };

  var specialProductSlider = function specialProductSlider(special, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(specialProduct_SpecialProduct, {
      tagLabel: special.badgeLabel,
      tagVariant: special.badgeStyle,
      heading: special.title,
      description: special.description,
      additionals: special.addOn,
      ctaLabel: special.callToActionLabel,
      ctaLink: special.callToActionUri,
      isOpenNewTab: special === null || special === void 0 ? void 0 : special.isOpenNewTab,
      imgUrl: special.image,
      videoUrl: special.videoUrl,
      hotSpots: generateHotSpot(special.left, special.top, special.imageHeading, special.imageDescription, special.placement),
      price: special.fromLabel,
      type: special.type,
      id: special.id,
      "data-cms-title": special.analyticTitle ? special.analyticTitle : special.title,
      variant: component.buttonStyle
    }, index);
  };

  if (totalTabs > 1) {
    var tabsToRender = [];

    for (var i = 0; i < totalTabs; i++) {
      tabsToRender.push({
        title: tabs[i],
        component: /*#__PURE__*/(0,jsx_runtime.jsx)(homeSlider_HomeSlider, {
          slideItems: component.items[tabs[i]],
          children: specialProductSlider
        })
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
      fluid: true,
      className: "py-l overflow-hidden",
      id: component.id,
      "data-cms-title": component.analyticTitle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
        text: component.title,
        mainHeadingRequired: true,
        alignment: component === null || component === void 0 ? void 0 : component.heading_position,
        container: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HomeTabs/* default */.Z, {
        tabsContent: tabsToRender,
        variant: component.tabStyle,
        tabType: component.tabType,
        alignment: component === null || component === void 0 ? void 0 : component.heading_position
      })]
    }, component.type + key);
  } else {
    var _tabs = Object.keys(component.items);

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
      fluid: true,
      className: "py-l overflow-hidden",
      id: component.id,
      "data-cms-title": component.analyticTitle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
        text: component.title,
        secondaryText: _tabs[0],
        className: "explore-our-section",
        mainHeadingRequired: true,
        alignment: component === null || component === void 0 ? void 0 : component.heading_position,
        container: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(homeSlider_HomeSlider, {
        slideItems: component.items[_tabs[0]],
        children: specialProductSlider
      })]
    }, component.type + key);
  }
};
var imageCardSlider = function imageCardSlider(component, key, analyticsData) {
  var tabs = !Array.isArray(component.items) && Object.keys(component.items);
  var totalTabs = tabs.length;
  var cardType = component.imageCardType == "2*3" ? "two-third" : "";

  var imageCardSlider = function imageCardSlider(card, index, array, type) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(imageCard_ImageCard, {
      title: card === null || card === void 0 ? void 0 : card.title,
      description: card === null || card === void 0 ? void 0 : card.description,
      image: card === null || card === void 0 ? void 0 : card.image,
      icon: card === null || card === void 0 ? void 0 : card.icon,
      ctaLink: card === null || card === void 0 ? void 0 : card.callToActionUri,
      ctaLabel: card === null || card === void 0 ? void 0 : card.callToActionLabel,
      type: type,
      id: card === null || card === void 0 ? void 0 : card.id,
      ctaVariant: component === null || component === void 0 ? void 0 : component.buttonStyle,
      isOpenNewTab: card === null || card === void 0 ? void 0 : card.isOpenNewTab,
      dataCMSTitle: card !== null && card !== void 0 && card.analyticTitle ? card === null || card === void 0 ? void 0 : card.analyticTitle : card === null || card === void 0 ? void 0 : card.title,
      analyticsData: renderComponent_objectSpread({
        link_type: "o",
        link_name: "".concat(analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.page_name, ": promo: p").concat(index + 1, ": ").concat(card !== null && card !== void 0 && card.title ? card === null || card === void 0 ? void 0 : card.title.toLowerCase() : "", ": ").concat(component !== null && component !== void 0 && component.title ? component === null || component === void 0 ? void 0 : component.title.toLowerCase() : "")
      }, analyticsData)
    }, index);
  };

  if (totalTabs > 1) {
    var tabsToRender = [];

    for (var i = 0; i < totalTabs; i++) {
      tabsToRender.push({
        title: tabs[i],
        component: /*#__PURE__*/(0,jsx_runtime.jsx)(homeSlider_HomeSlider, {
          slideItems: component.items[tabs[i]],
          type: cardType,
          className: component.type === "product_card" && "product_card",
          children: imageCardSlider
        })
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
      fluid: true,
      className: "py-l overflow-hidden",
      id: component.id,
      "data-cms-title": component.analyticTitle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
        text: component.title,
        className: "explore-our-section",
        mainHeadingRequired: true,
        alignment: component === null || component === void 0 ? void 0 : component.heading_position
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HomeTabs/* default */.Z, {
        tabsContent: tabsToRender,
        variant: component.tabStyle,
        tabType: component.tabType,
        alignment: component === null || component === void 0 ? void 0 : component.heading_position
      })]
    }, component.type + key);
  } else if (totalTabs == 1) {
    var _tabs2 = Object.keys(component.items);

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
      fluid: true,
      className: "py-l overflow-hidden",
      id: component.id,
      "data-cms-title": component.analyticTitle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
        text: component.title,
        secondaryText: _tabs2[0],
        mainHeadingRequired: true,
        alignment: component === null || component === void 0 ? void 0 : component.heading_position
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(homeSlider_HomeSlider, {
        slideItems: component.items[_tabs2[0]],
        type: cardType,
        className: component.type === "product_card" && "product_card",
        children: imageCardSlider
      })]
    }, component.type + key);
  } else {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
      fluid: true,
      className: "py-l overflow-hidden",
      id: component.id,
      "data-cms-title": component.analyticTitle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homePageHeading/* default */.Z, {
        secondaryText: component.title,
        textClassName: component.type === "product_card" && "product_card",
        mainHeadingRequired: true,
        alignment: component === null || component === void 0 ? void 0 : component.heading_position
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(homeSlider_HomeSlider, {
        slideItems: component.items,
        type: cardType,
        className: component.type === "product_card" && "product_card",
        children: imageCardSlider
      })]
    }, component.type + key);
  }
};
var renderVideo = function renderVideo(component, setState) {
  var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "1284";
  var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "552";
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;

  var generateVideoSrc = function generateVideoSrc(videoUrl) {
    if (videoUrl.indexOf("//www.youtube.com/") !== -1) {
      return {
        techOrder: ["youtube"],
        sources: [{
          type: "video/youtube",
          src: videoUrl
        }]
      };
    }

    return {
      sources: [{
        type: "video/mp4",
        src: videoUrl
      }]
    };
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(VideoBanner, {
    metaData: component,
    config: Object.assign({
      setInitialState: setState
    }, {
      autoplay: false,
      controls: true,
      aspectRatio: "".concat(width, ":").concat(height),
      preload: "auto",
      poster: component.thumbnail,
      icon: "".concat(imagePrefix, "/assets/images/video-banner-play-icon.svg")
    }, generateVideoSrc(component.video))
  });
};

/***/ }),

/***/ 90892:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hero-carousel":"HeroCarousel_hero-carousel__i1UNR","owl-dots":"HeroCarousel_owl-dots__CK_HK","owl-dot":"HeroCarousel_owl-dot__3dpEs","slide":"HeroCarousel_slide__jglbG","content":"HeroCarousel_content__rxw7J","content__title":"HeroCarousel_content__title__GxpRa","content__heading":"HeroCarousel_content__heading__Nzulf","content__description":"HeroCarousel_content__description__zVuwa","content__cta":"HeroCarousel_content__cta__tXqzH","content--light":"HeroCarousel_content--light__m9n_u","content--dark":"HeroCarousel_content--dark__fCuXr","nav":"HeroCarousel_nav__NNMt1","prev-arrow":"HeroCarousel_prev-arrow__fsCsa","next-arrow":"HeroCarousel_next-arrow__DCcYd"};

/***/ }),

/***/ 72476:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-price-height":"productGridList_card-price-height__vrD9N","deal1":"productGridList_deal1__s6p0S","owl-carousel":"productGridList_owl-carousel__VfV_Z","owl-stage-outer":"productGridList_owl-stage-outer__wvOOF","custom-container":"productGridList_custom-container__maaTT","custom-container-button":"productGridList_custom-container-button__C3Oyi","grid-container":"productGridList_grid-container__2LXCl","carousel-container-deal":"productGridList_carousel-container-deal__GBPd4","grid-container__mobile":"productGridList_grid-container__mobile__c_HPb","carousel-container":"productGridList_carousel-container__EUUpo","disabled":"productGridList_disabled__AcIeO"};

/***/ }),

/***/ 45159:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"small-cards-carousel-container":"SmallCardsCarousel_small-cards-carousel-container__5Pa4s","custom-owl--nav":"SmallCardsCarousel_custom-owl--nav__DRBA9","smallcards-title":"SmallCardsCarousel_smallcards-title__7jMW_","small-title":"SmallCardsCarousel_small-title__B4LV7","image-container":"SmallCardsCarousel_image-container__aEXYs","image-container__content":"SmallCardsCarousel_image-container__content__hYBOU","image-container__logo":"SmallCardsCarousel_image-container__logo__p8vwM","image-container__category-name":"SmallCardsCarousel_image-container__category-name__HcbJa","image-container__title":"SmallCardsCarousel_image-container__title__mfZLh","image-container__description":"SmallCardsCarousel_image-container__description__OTKHg","logo":"SmallCardsCarousel_logo__IGLIA","icon":"SmallCardsCarousel_icon__SN0xl","image":"SmallCardsCarousel_image__keiWK"};

/***/ }),

/***/ 70134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LEFT":"cardsCarousel_LEFT__jxp3V","CENTER":"cardsCarousel_CENTER__yfXRT","content-container":"cardsCarousel_content-container__APnsT","owl--nav":"cardsCarousel_owl--nav__fTg80","content-item":"cardsCarousel_content-item__Xlcrh","mobile-card-view":"cardsCarousel_mobile-card-view__K6olr"};

/***/ }),

/***/ 98679:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel-container":"Carousel_carousel-container__tO6dp","item":"Carousel_item__sJevR","owl--dots":"Carousel_owl--dots__lJEkt","arrow":"Carousel_arrow__jou2B","arrow--prev":"Carousel_arrow--prev__YuUcT","arrow--next":"Carousel_arrow--next__yuwDq","owl-stage-outer":"Carousel_owl-stage-outer__q5Bj3"};

/***/ }),

/***/ 34057:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"home-page-heading":"homePageHeading_home-page-heading__juShY","main-heading":"homePageHeading_main-heading___21HR","secondary-heading":"homePageHeading_secondary-heading__z2LJ4","secondary-grey-heading":"homePageHeading_secondary-grey-heading__56AJw","sub-heading":"homePageHeading_sub-heading__gdek_","description-style":"homePageHeading_description-style__qsHQC","product_card":"homePageHeading_product_card__ke1t6"};

/***/ }),

/***/ 14337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"home-slider":"homeSlider_home-slider__vlMAF","home-slider__carousel":"homeSlider_home-slider__carousel__BuJ0i","owl-carousel":"homeSlider_owl-carousel__AZIBY","owl-stage-outer":"homeSlider_owl-stage-outer__unYuA","owl-stage":"homeSlider_owl-stage__uPYGR"};

/***/ }),

/***/ 40001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"underline":"homeTabs_underline__0C7Fi","tabs-design__nav":"homeTabs_tabs-design__nav__NMald","home-tabs-container":"homeTabs_home-tabs-container__Nn9xX","tabs-design__nav--left":"homeTabs_tabs-design__nav--left__lXyVY","tabs-design__nav--right":"homeTabs_tabs-design__nav--right__Px4AE","tab-link--active":"homeTabs_tab-link--active__7YqZn","tab-link":"homeTabs_tab-link__h6Vnm","active":"homeTabs_active__wQ8Uh","tabs-design__nav--black-with-line":"homeTabs_tabs-design__nav--black-with-line__KVOxD","tabs-design__nav--black-without-line":"homeTabs_tabs-design__nav--black-without-line__LB7tU","tabs-design__nav--red-with-line":"homeTabs_tabs-design__nav--red-with-line__88vl5","tabs-design__nav--red-without-line":"homeTabs_tabs-design__nav--red-without-line__D1Gxw","tabs-design__nav--large-black":"homeTabs_tabs-design__nav--large-black__6jIX_","tabs-design__content":"homeTabs_tabs-design__content__Xp2B9","tabs-design__nav--line-secondary":"homeTabs_tabs-design__nav--line-secondary__xxBFb","tabs-design__nav--line-primary":"homeTabs_tabs-design__nav--line-primary__z6bwb","tabs-design__nav--button":"homeTabs_tabs-design__nav--button__5tKXq","tabs-design__nav--pill":"homeTabs_tabs-design__nav--pill__JMQtG","past-usage-tab":"homeTabs_past-usage-tab__Xnn4E","nav-alignment":"homeTabs_nav-alignment__fchxp","upgrade-custom":"homeTabs_upgrade-custom__7Y_qq"};

/***/ }),

/***/ 99305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hot-spot":"hotSpot_hot-spot__afqs8","hot-spot__point":"hotSpot_hot-spot__point__yZ0Jm","pulse":"hotSpot_pulse__VvZiK","hot-spot__images":"hotSpot_hot-spot__images__gnCME","tooltip":"hotSpot_tooltip__ErHfy","tooltip__container":"hotSpot_tooltip__container__YWIC2","tooltip__arrow":"hotSpot_tooltip__arrow__Oq1J_","tooltip__arrow--left":"hotSpot_tooltip__arrow--left__tneIP","tooltip__arrow--right":"hotSpot_tooltip__arrow--right__6Crkw","tooltip__arrow--top":"hotSpot_tooltip__arrow--top__aJ_HJ","tooltip__arrow--bottom":"hotSpot_tooltip__arrow--bottom__h70im","tooltip__heading":"hotSpot_tooltip__heading__CVEmk","tooltip__description":"hotSpot_tooltip__description__M4oew","tooltip--left":"hotSpot_tooltip--left__6J_Da","tooltip--right":"hotSpot_tooltip--right__e2p_p","tooltip--top":"hotSpot_tooltip--top__9hHl5","tooltip--bottom":"hotSpot_tooltip--bottom__AdKEx","lightbox":"hotSpot_lightbox__Zz09o"};

/***/ }),

/***/ 2116:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-container":"imageCard_card-container__6poZj","card-gradient":"imageCard_card-gradient__QNVxi","card-info":"imageCard_card-info__xLaHh","card-icon":"imageCard_card-icon__tdQnX","card-title":"imageCard_card-title__UOsTK","card-heading":"imageCard_card-heading__nn_sl","card-button":"imageCard_card-button__oXj7x","custom-style":"imageCard_custom-style__1NvSA","two-third":"imageCard_two-third__zjtFm"};

/***/ }),

/***/ 64479:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"proposition":"Proposition_proposition__hXxnc","proposition__text":"Proposition_proposition__text__RidVW","proposition__text--align-right":"Proposition_proposition__text--align-right__CCg6Q","proposition__text--align-left":"Proposition_proposition__text--align-left__bba_U","proposition__icon":"Proposition_proposition__icon__W9Ruy","proposition__divider":"Proposition_proposition__divider__fscyI","proposition--active":"Proposition_proposition--active__bqhXR","proposition--static":"Proposition_proposition--static__p2tr_","proposition__title":"Proposition_proposition__title__pQp4C"};

/***/ }),

/***/ 86539:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"specialProduct_card__3Lf6B","card__media":"specialProduct_card__media__rWO4H","tag":"specialProduct_tag__1aSbs","card-bottom-container":"specialProduct_card-bottom-container__TdPno","card__title":"specialProduct_card__title__DwIBp","card__description":"specialProduct_card__description__gRWU2","card__label":"specialProduct_card__label__FS0kT","card__footer":"specialProduct_card__footer__HxqpR","card__price":"specialProduct_card__price__rRedc","card__cta":"specialProduct_card__cta__qiyLW"};

/***/ }),

/***/ 6696:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"order-load-more":"OrderHistoryLoadMore_order-load-more__pVWna","order-load-more--label":"OrderHistoryLoadMore_order-load-more--label__vflkV","order-load-more--btn":"OrderHistoryLoadMore_order-load-more--btn__DKjJg","order-load-list-end":"OrderHistoryLoadMore_order-load-list-end__YsFV4"};

/***/ }),

/***/ 21979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shop-all":"DealCatalog_shop-all___s9j_","heading":"DealCatalog_heading__U1a1u","grid-heading":"DealCatalog_grid-heading__3kmv4","deal-carousel-container":"DealCatalog_deal-carousel-container__x_7qC"};

/***/ }),

/***/ 4127:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container-mobile":"FourQuadInteractive_container-mobile__3Iw2Z","quadrant":"FourQuadInteractive_quadrant___DQW_","quadrant-mobile":"FourQuadInteractive_quadrant-mobile__GJGXn","carousel-container":"FourQuadInteractive_carousel-container__sV4lA","carousel-nav":"FourQuadInteractive_carousel-nav__KXj9v","carousel-nav--static":"FourQuadInteractive_carousel-nav--static__CK_Rm","quadrant-image":"FourQuadInteractive_quadrant-image__OvqIx","quadrant-image-container":"FourQuadInteractive_quadrant-image-container__4nbab","main-heading":"FourQuadInteractive_main-heading__h4bJV","main-description":"FourQuadInteractive_main-description__Nmcga","heading":"FourQuadInteractive_heading__9018k"};

/***/ }),

/***/ 54239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shop-all":"productCatalog_shop-all__FqKAe","shop-all-big":"productCatalog_shop-all-big__GxUb_","heading":"productCatalog_heading__SZZrj","heading-carousel":"productCatalog_heading-carousel__bv69i","product-carousel-container":"productCatalog_product-carousel-container__m9DWB"};

/***/ }),

/***/ 38588:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"head-text":"StepProcess_head-text__6DIOw","process-container":"StepProcess_process-container__gOt0J","process-description":"StepProcess_process-description__TK9cS","process-heading":"StepProcess_process-heading__k6bd9","process-number":"StepProcess_process-number__qicGy","process-details":"StepProcess_process-details__dCjt_","active-text":"StepProcess_active-text__WGP9X","inactive-text":"StepProcess_inactive-text__LVH6r","progress-container":"StepProcess_progress-container__xENHq","progress-value":"StepProcess_progress-value__nqGXW","progress-bar":"StepProcess_progress-bar__sQkYK","inactive-progessbar":"StepProcess_inactive-progessbar__h8VUv","top-col":"StepProcess_top-col__fZyUL","image-container-landscape":"StepProcess_image-container-landscape__vFjUf","image-container-square":"StepProcess_image-container-square__pI6if","custom-container-button":"StepProcess_custom-container-button__PPtus","prev-btn":"StepProcess_prev-btn__MmRw_","next-btn":"StepProcess_next-btn__SW5st","mobile-container":"StepProcess_mobile-container__4f_kB","image-landscape":"StepProcess_image-landscape__8sOov","image-square":"StepProcess_image-square__TkZYM"};

/***/ })

}]);